const en = {
  nav: {
    home: 'Home', tournaments: 'Tournaments', teams: 'Teams',
    athletes: 'Athletes', login: 'Sign in', logout: 'Sign out', profile: 'Profile',
    // #666 — the busy label of the two sign-out buttons.
    signingOut: 'Sign-out in progress…',
    // #666 — the warning when the sign-out request got no 2xx answer. The browser
    // stored the key of the pending sign-out, so the next page load sends the request again.
    signOutIncomplete: 'The server did not confirm the sign-out. Your session can still be active on this device. When the device is online, reload the page. The app then sends the sign-out again.',
    // #666 — the same warning when the browser refused that key (a blocked or full
    // storage): no page load sends the request again.
    signOutIncompleteNoRetry: 'The server did not confirm the sign-out. Your session can still be active on this device. When the device is online, sign in. Then sign out again.',
    officials: 'Officials',
    federationName: 'Lithuanian Muaythai Federation',
    federationShort: 'LMF',
    help: 'Help',
  },
  // #458 — the app shell: the error screen, the version banner, the 404 page.
  app: {
    crashText: 'An unexpected error occurred.',
    reload: 'Reload',
    reloadOffline: 'The server does not answer. Check the connection, then try again.',
    newVersion: 'New version available',
    update: 'Update',
    pageNotFound: 'Page not found',
  },
  common: {
    red: 'Red', blue: 'Blue', draw: 'Draw', save: 'Save', cancel: 'Cancel',
    submit: 'Submit', loading: 'Loading…', error: 'Something went wrong',
    required: 'Required', edit: 'Edit', delete: 'Delete', confirm: 'Confirm',
    back: 'Back', stage: 'Stage', ring: 'Ring', bout: 'Bout', round: 'Round',
    challenge: 'Challenge', final: 'Final', semifinal: 'Semi-final', quarterfinal: 'Quarter-final',
    round16: 'R16', round32: 'R32',
    total: 'Total', points: 'Points', warnings: 'Warnings', knockdowns: 'KD', cautions: 'Cautions', caution: 'Caution',
    winner: 'Winner', decision: 'Decision', result: 'Result', pending: 'Pending',
    current: 'Current', scored: 'Scored', locked: 'Locked', live: 'Live',
    yes: 'Yes', no: 'No', close: 'Close', add: 'Add', create: 'Create',
    // #665 review — the confirm button of a question that ends with "Continue?".
    continue: 'Continue',
    name: 'Name', location: 'Location', date: 'Date', status: 'Status',
    gender: 'Gender', age: 'Age', weight: 'Weight', team: 'Team', days: 'Days', rings: 'Rings', print: 'Print',
    male: 'Male', female: 'Female', search: 'Search', remove: 'Remove',
    // #531 — a DIVISION (a bout, a bracket, a group of registrations) and the
    // initial of the short badge. English uses one form; Lithuanian needs the
    // plural for a division ("Vyrai") and its own initials ("V" / "M").
    maleDivision: 'Male', femaleDivision: 'Female', maleShort: 'M', femaleShort: 'F',
    // #531 — a count takes the plural form of the language (countLabel):
    // Lithuanian has three (1 kova, 2 kovos, 10 kovų).
    boutsOne: '{n} bout', boutsFew: '{n} bouts', boutsOther: '{n} bouts', ageShort: '{n} y',
    // #552 — the button that creates the bouts of a modal, with the count.
    createBoutsOne: 'Create {n} Bout', createBoutsFew: 'Create {n} Bouts', createBoutsOther: 'Create {n} Bouts',
    fightersOne: '{n} boxer', fightersFew: '{n} boxers', fightersOther: '{n} boxers',
    // #551 — the registered boxers on a tournament card.
    boxersOne: '{n} boxer', boxersFew: '{n} boxers', boxersOther: '{n} boxers',
    approve: 'Approve', reject: 'Reject', join: 'Join', leave: 'Leave',
    you: 'You', myTeam: 'My team', myBout: 'My bout',
    today: 'Today', upcoming: 'Upcoming', past: 'Past',
    viewAll: 'View all', noUpcoming: 'No upcoming events',
    noFurther: 'No further events scheduled', upNext: 'Up Next',
    vs: 'vs', tbd: 'TBD', boutWinner: 'Bout {n} winner',
    confirmed: 'Confirmed', notConfirmed: 'Not confirmed',
    ready: 'Ready',
    // #663 — a count of filter results and of audit entries, in the three forms (countLabel).
    resultsOne: '{n} result', resultsFew: '{n} results', resultsOther: '{n} results',
    entriesOne: '{n} entry', entriesFew: '{n} entries', entriesOther: '{n} entries',
    noData: 'No data', promote: 'Promote',
    allGenders: 'All genders', allTeams: 'All teams', clear: 'Clear', select: 'select',
    // #595 — the back link of a detail page names its list.
    allTournaments: 'All tournaments', allAthletes: 'All athletes',
    notifyMe: 'Notify me', notifyOn: 'Subscribed',
    // #515 — the prompt a guest gets from the bout bell
    guestBellTitle: 'Get bout notifications',
    guestBellText: 'Sign in to get a notification when this bout is next and when it starts. The notifications guide tells how the notifications work.',
    guestBellGuide: 'Notifications guide',
    // The shared words of the modals (2026-09-26).
    saving: 'Saving…', optional: '(optional)',
    // #693 — the button of a modal footer that opens the menu of two or more record actions.
    actions: 'Actions',
    loadFailed: 'The data did not load', loadFailedHint: 'Check the connection, then try again.', retry: 'Try again',
    tournamentNotFound: 'Tournament not found', boutNotFound: 'Bout not found',
    teamNotFound: 'Team not found', athleteNotFound: 'Athlete not found',
    // #458 — texts that the code held in English.
    messageTo: 'Message to {name}:',
    listNotRefreshed: 'Saved. The list did not refresh: reload the page.',
    empty: {
      tournamentsHint: 'Once an event is scheduled it will show up here.',
      upcomingHint: 'No tournaments are coming up. Check back soon.',
      historyHint: 'Past tournaments will appear here once they happen.',
      teamsHint: 'Be the first to register a team for the federation.',
      athletesHint: 'Try adjusting filters or check back later.',
      membersHint: 'Once coaches or athletes join, they will appear here.',
      profileAthleteHint: 'Coaches and admins can link an athlete record to your account.',
      requestsHint: 'Pending requests will show up here when submitted.',
      auditHint: 'Audit log entries will appear once actions are recorded.',
      // #664 — a filter hides the rows: the table, the search or the option "{option}".
      auditFilteredHint: 'A filter hides the entries. Change the table or the search, or turn off "{option}".',
      auditTitle: 'No audit entries',
      usersTitle: 'No users found',
      usersHint: 'Try adjusting the filter.',
      claimsHint: 'When members request to claim an account, requests appear here.',
      joinsHint: 'When athletes ask to join a team, requests appear here.',
    },
  },
  bout: {
    card: 'Bout Card',
    // #531 — the Round Totals table and the markers of both score tables.
    // The legend names the letters that the markers show.
    roundTotals: 'Round Totals',
    // Cautions are for the officials only (PublicScoreboard): the public
    // legend has no C; the jury table shows C and says so.
    roundTotalsLegend: 'Jury-approved round scores · W = Warning · K = Knockdown',
    juryMarkersLegend: 'W = Warning · K = Knockdown · C = Caution',
    // #600 — the backup timer of the Sarama card. The jury knows TIME and CHOCK: the buttons do not name them.
    timer: 'timer', timerStart: 'Start', timerStop: 'Stop', timerContinue: 'Continue', timerReset: 'Reset', timerOnDisplay: 'Show on the ring display',
    // #599 — the rows of the jury card.
    majority: 'Majority', noMajority: 'No majority', roundApproved: 'Approved',
    lowerScore: 'Lower the points: {side}', raiseScore: 'Raise the points: {side}',
    roundN: 'Round {n}', judge: 'Judge',
    markWarning: 'Warning', markKnockdown: 'Knockdown', markCaution: 'Caution',
    ringReferee: 'Ring Referee', sideJudges: 'Side Judges',
    // #622 — the level of a bout and the experience of a boxer (the roles of the Officials menu).
    levelPill: 'Level: {level}', levelPro: 'Pro', levelHigh: 'High', levelMedium: 'Medium', levelLow: 'Low',
    levelEstimated: '≈ An estimate: the registration of a boxer has no recorded experience.',
    experienceLabel: 'Experience',
    roundScore: 'Round Score', submit_verdict: 'Submit Verdict', fullBout: 'full bout',
    ringRefRequiredHint: 'Assign a ring referee in the Officials section above before submitting the verdict.',
    // #664 — the verdict form: the field of the round of the end, and the note about the scoreboard.
    roundEnded: 'Round ended',
    scoreboardShowsRounds: 'Scoreboard will show totals for: {rounds}',
    noRoundsApproved: 'No rounds approved for public display. Tick rounds above to show their totals on the scoreboard.',
    approveFewCards: 'Only {cards} of {min} judges scored round {round}. Approve the round?',
    approveRound: 'Approve Round',
    jury: 'Jury',
    // The role tag on an official's card, and the Sarama Stop (2026-09-25).
    sideJudge: 'Side judge', saramaStop: 'Stop the music',
    noJury: 'No jury assigned', ageGroup: 'Age group', weightClass: 'Weight class',
    ageGroupShort: 'Age', weightClassShort: 'Wt', // #661 — the labels of the pills on the bout card
    // #592 — IFMA v3.057 Rule 31.3: the restricted strikes of a division.
    strikesNoHead: 'No strikes to the head',
    strikesNoKneeElbowHead: 'No knee or elbow strikes to the head',
    editRingReferee: 'Edit Ring Referee', noRingReferee: 'no ring referee', ringRefAssignedMark: 'assigned',
    // The jury-pool notice of the officials block: it was English in every language.
    notInJuryPool: 'You are in the referee pool, but not in the jury pool. To claim the jury of a bout, tick "Jury Pool" on the Officials tab.',
    openOfficialsTab: 'Open the Officials tab',
    // The next-bout banner of the bout page, and the screens of the ring TV.
    nextBoutStarting: 'Next bout starting...', redirectingIn: 'Redirecting in {n}s',
    goNow: 'Go now', stayHere: 'Stay here', editBout: 'Edit bout',
    waitingForNextBout: 'Waiting for next bout…',
    // IFMA v3.057 §30 names the outcomes: §30.1 Win on Points (WP), §30.3 Knock-Out (KO).
    wpLabel: 'Win on Points', koLabel: 'Knock-Out', tkoLabel: 'Technical KO',
    rscLabel: 'Referee Stopped', woLabel: 'Walk Over', dqLabel: 'Disqualification',
    claimJury: 'Claim as Jury', unclaimJury: 'Unclaim jury',
    joinSide: 'Join', leaveSide: 'Leave',
    score_hint_10_9: 'Small margin: the winner of the round used up to 7 more scoring skills (IFMA §29.2.1).',
    score_hint_10_8: 'Large margin: 8 to 14 more scoring skills (IFMA §29.2.1).',
    score_hint_10_7: 'Total domination: 15 to 21 more scoring skills (IFMA §29.2.1).',
    score_hint_10_10: 'Even round: the boxers are equal in scoring skills and in force (IFMA §29.2.3).',
    // #469 — equal final scores where a draw is not allowed.
    tieHelp: 'Equal final scores. Pick the winner by the whole bout (IFMA §29.3): first more scoring skills, then more force. If still equal, any one of these decides: less exhaustion, more initiative, better defence, better style, fewer infringements.',
    roundsWon: 'Rounds won on the judges\' cards: Red {red} – Blue {blue} (information only)',
    // #458 — toasts, confirm and prompt texts that the code held in English.
    juryClaimed: 'Jury claimed', juryClaimedLive: 'Jury claimed', juryUnclaimed: 'Jury unclaimed',
    joinedSideJudges: 'Joined as side judge', leftSideJudges: 'Left side judges',
    // #664 — the text of a refused seat action, when the answer holds no text of its own.
    juryClaimFailed: 'Could not assign as jury', juryUnclaimFailed: 'Could not unclaim jury',
    sideJoinFailed: 'Could not assign as side judge', sideLeaveFailed: 'Could not remove from side judges',
    ringRefSaveFailed: 'Could not save ring referee',
    sideJudgesUpdated: 'Side judges updated ({n}/5)', ringRefereeAssigned: 'Ring referee assigned',
    // #589 — a ring referee left the referee pool, so the bout has none.
    ringRefereeRemoved: 'The bout has no ring referee now',
    verdictToast: 'Verdict: {winner} wins by {outcome}',
    verdictConfirm: 'Submit verdict: {winner} wins by {outcome}? This cannot be undone.',
    updated: 'Bout updated',
    pingRingReferee: 'Bout #{n} — attention needed in the ring',
    pingSideJudge: 'Bout #{n} — please submit your scores',
    // #557 — the bell button next to an official on the page of a live bout (the jury only).
    notifyOfficial: 'Notify the official',
    tiedUseDraw: 'Scores are tied ({redScore}-{blueScore}). Use the DRAW outcome, or check the round scores again.',
    tiedPickWinner: 'Scores are tied ({redScore}-{blueScore}). Tournament bouts cannot draw — pick a winner using IFMA tiebreak criteria.',
  },
  tournament: {
    create: 'Create Tournament',
    deleteConfirm1: 'Delete this tournament permanently?',
    deleteConfirm2: 'Last check: the tournament, its bouts, results and registrations are deleted. This cannot be undone. Continue?',
    bracket: 'Bracket',
    bouts: 'Bouts',
    delete: 'Delete Tournament',
    facebookEvent: 'Facebook Event Link',
    championship: 'Championship', openRing: 'Open Ring',
    // #536 — the third type: a championship part and an open-ring part.
    hybrid: 'Championship + Open Ring',
    typeLockedHint: 'The type can change only while the tournament has no bouts. Open Ring and Championship + Open Ring can change into each other at any time.',
    regDeadline: 'Registration deadline',
    regDeadlineShort: 'Deadline', // the deadline pill on a phone: the full label wrapped to two lines
    // The Boxers tab: the full list, and the Confirmed chip as a filter (2026-09-25).
    noBoxersRegistered: 'No boxers registered yet', noConfirmedBoxers: 'No confirmed boxers yet',
    showConfirmedBoxers: 'Show only the confirmed boxers', showAllBoxers: 'Show all boxers',
    // The registration panel (2026-09-25).
    registrationOpen: 'Registration is open', registrationCloses: 'Closes {date}',
    registrationDeadlinePassed: 'The deadline was {date}', registeredBoxers: 'Boxers registered: {n}',
    overview: 'Overview', athletes: 'Boxers', officials: 'Officials', brackets: 'Brackets', teamRatings: 'Ratings',
    maxWeightKgLabel: 'Max weight (kg)',
    tournamentName: 'Tournament name', ringName: 'Ring name', ringNameExample: 'e.g. Ring A', editDetails: 'Edit details', lockBouts: 'Lock bouts', unlockBouts: 'Unlock bouts',
    boutsLocked: 'Bout list locked', coachEditsLocked: 'Coach corrections disabled',
    boutsLockedDetail: 'You can still edit rings, officials, and dates for pending bouts.',
    boutsPlanning: 'Bout list in planning stage',
    boutsPlanningDetail: 'Not yet locked — TMs may still add, edit, or reorder bouts.',
    lockCoachEdits: 'Disable coach corrections', unlockCoachEdits: 'Enable coach corrections',
    removeLogo: 'Remove logo', changeLogo: 'Change logo', addLogo: 'Add logo',
    removeLogoConfirm: 'Remove the logo of the tournament?',
    lockRegistration: 'Lock registration', unlockRegistration: 'Unlock registration',
    registrationComplete: 'Registration complete',
    weighInCompleted: 'Weigh-in completed for this day',
    resetBouts: 'Reset Bouts & Unlock', ringAuto: 'Ring: auto',
    seeds: 'Draw order', matchups: 'Pairs',
    confirmBracket: 'Confirm Bracket',
    refereePoolJoinBtn: 'Join pool',
    refereePoolLeaveBtn: 'Leave',
    refereePoolInBadge: 'In pool',
    // #589 — the Officials tab: the empty list, the days of a member, and the confirm modals.
    noRefereesInPool: 'The referee pool is empty.',
    allDays: 'All days',
    leavePoolTitle: 'Leave the Referee Pool',
    removeRefereeTitle: 'Remove the Referee',
    pingTitle: 'Send a Notification',
    pingSend: 'Send',
    configureBouts: 'Configure Bouts',
    registerBoxers: 'Register Boxers',
    guestRegisterTitle: 'Register Boxers',
    guestRegisterText: 'Registration is open. A coach or a Head Coach registers the boxers of a team. Sign in with a coach account, or read the coach guide to get started.',
    guestRegisterGuide: 'Coach guide',
    selectTeam: 'select team',
    ageGroupLabel: 'Age group', weightClassLabel: 'Weight class',
    registrationWeightRequired: 'Enter the weight of every selected athlete.',
    removeRegistration: 'Remove from tournament',
    // #552 — the Edit Registration modal. The aria name is pinned by e2e as a
    // substring ('Edit registration'), so keep the two words.
    editRegistration: 'Edit Registration',
    selectAgeGroupFirst: '— Select the age group first —',
    removeRegistrationBracketHint: 'A bracket holds this class. To remove the boxer, reset the bouts first.',
    // #552 — the Edit Ring modal; it held English.
    editRingTitle: 'Edit Ring', ringMinAgeGroup: 'Min age group', ringMaxAgeGroup: 'Max age group', ringAny: 'Any',
    // The empty option of the max-weight select (lt needs the masculine form).
    ringAnyWeight: 'Any',
    printAthletes: 'Print Boxers', printBouts: 'Print Bout List', printBrackets: 'Print Brackets',
    weighIn: 'Weigh-in', endWeighIn: 'End Weigh-in', checkinTab: 'Check-in',
    ageGroupsTaken: 'Age groups', // #532 — the card and the header
    // #531 — labels that the Overview, Bouts and Officials tabs wrote in English.
    addRing: '+ Add ring', noRings: 'No rings yet.', addRingsHint: ' Add rings to assign bouts.', ringDisplayLink: 'Display', ringOverlayLink: 'Overlay',
    managersTitle: 'Tournament Managers', matchFighters: 'Match Boxers',
    // #536 — a hybrid: the plan confirm needs a tournament with no other bouts.
    hybridPlanFirst: 'Confirm the bout plan first, then add the open-ring bouts. You can confirm the plan only while the tournament has no other bouts.',
    // #547 — a hybrid draws its brackets after the check-in: a bout made before
    // the plan confirm blocks every later bracket (BOUTS_ALREADY_EXIST).
    hybridNoPlanConfirm: 'No bout plan is confirmed yet. A bout made now can take boxers who belong in a bracket, and any bout blocks every later bracket. Draw the brackets and confirm the plan first. Continue?',
    regHasBout: 'This boxer has a bout. Delete the bout first to change the class.',
    noBrackets: 'No brackets yet.', hintGenBrackets: 'Go to the Boxers tab and generate brackets per age/weight group.',
    noBouts: 'No bouts yet.', hintCreateBouts: 'Create the bouts by hand or generate the brackets.', noBracketData: 'No bracket data',
    showBracket: 'Show bracket', hideBracket: 'Hide bracket',
    creatingBouts: 'Creating bouts...', resetConfirm: 'Reset all bouts? This deletes every bout, sets the brackets back to draft and unlocks the tournament. The weigh-ins stay.',
    bracketConfirmed: 'Bracket confirmed',
    bracketPreview: 'Bracket Preview',
    // #465 — the IFMA draw in the bracket preview.
    drawTitle: 'Draw', drawAgain: 'Draw again',
    drawAgainConfirm: 'Draw again? Your swaps will be lost.',
    drawUndo: 'Undo swaps',
    drawHint: 'The lot gives the byes and the pairs (IFMA §16). To swap two boxers, drag one boxer onto the other.',
    drawByes: 'Byes', drawFirstSeries: 'First series',
    drawMovedByHand: 'Moved by hand',
    drawByeMoved: 'A bye moved by hand: the lot gave it to a different boxer.',
    bracketTruncated: '{total} boxers are confirmed in this class. A bracket holds a maximum of 32 boxers. The 32 boxers with the most experience are in the draw.',
    drawTeamMates: 'Team mates', drawMeetIn: 'can meet in {stage}', drawFirstContest: 'first bout',
    drawExperience: 'Experience: {n}',
    assignedBout: 'Assigned bout', // #661 — the title of the bout number on a registration
    boutPreview: 'Bout Preview', confirmAndCreate: 'Confirm & Create Bouts', viewBoutPlan: 'View Bout Plan',
    confirmAndCreateConfirm: 'Confirm the bout plan and create the bouts?',
    breakNeeded: 'Break needed',
    assignedTM: 'Assigned as TM', inBoxerPool: 'competing',
    inRefPool: 'in ref pool', inJuryPool: 'in jury pool',
    noTournaments: 'No tournaments yet',
    // #627 — an empty list under the country filter of the URL names the filter.
    noCountryMatch: 'No tournament matches the country filter: {country}.',
    livestream: 'Live Stream',
    draft: 'Draft', startBout: 'Start',
    ringBusyBoutLive: 'Ring busy — Bout #{n} live',
    startDay: 'Start', reassignBouts: 'Reassign Bouts', manualAssignment: 'Manual Assignment',
    confirmEndWeighin: 'Confirm End Weigh-in',
    ratingsFinal: 'bouts scored — final standings',
    ratingsPartial: 'bouts scored — standings may change',
    removeFromPool: 'Remove from pool',
    // #458 — toasts, confirm and prompt texts that the code held in English.
    startBoutConfirm: 'Start bout #{n}? This sets it as live for {ring}.',
    startBoutConfirmNoRing: 'Start bout #{n}? This sets it as live for this ring.',
    startDayConfirm: 'Start {day}? First bout on each ring will go live.',
    lockBoutsConfirm: 'Lock the bout list? This hides create/edit controls for all users.',
    unlockBoutsConfirm: 'Unlock the bout list?',
    lockCoachEditsConfirm: 'Disable coach corrections? After this, coaches cannot register, change or remove a boxer.',
    unlockCoachEditsConfirm: 'Enable coach corrections?',
    lockRegistrationConfirm: 'Lock registration? This also disables coach corrections. After this, you cannot change the confirmed status.',
    unlockRegistrationConfirm: 'Unlock registration?',
    deleteBoutConfirm: 'Delete this bout permanently?', deleteBoutNumberConfirm: 'Delete bout #{n}?',
    boutDeleted: 'Bout deleted', boutCreated: 'Bout created', boutUpdated: 'Bout updated',
    deleteBracketConfirm: 'Delete this bracket?', bracketDeleted: 'Bracket deleted',
    ringAdded: 'Ring "{name}" added', ringDeleted: 'Ring "{name}" deleted', ringUpdated: 'Ring updated',
    deleteRingConfirm: 'Delete ring "{name}"?',
    removeManagerConfirm: 'Remove {name} as manager?',
    leavePoolConfirm: 'Leave the referee pool? You lose each seat on a pending bout.',
    leftPool: 'Left referee pool', joinedPool: 'Joined referee pool',
    removeRefereeConfirm: 'Remove this referee from the pool? The referee loses each seat on a pending bout.',
    removeNamedRefereeConfirm: 'Remove {name} from the referee pool?',
    refereeRemoved: 'Referee removed', refereeAdded: 'Referee added', refereeUpdated: 'Referee updated',
    pingTournament: '{tournament} — attention needed', fallbackName: 'Tournament',
    notificationSent: 'Notification sent to {name}',
    // #557 review — the title and the aria-label of the bell button next to a member of the referee pool.
    notifyPoolMember: 'Send a notification to {name}',
    removeRegistrationConfirm: 'Remove this boxer from the tournament?',
    registrationRemoved: 'Registration removed', registrationUpdated: 'Registration updated',
    weighinEndedToast: 'Weigh-in ended. {n} WO(s).',
    endWeighinConfirm: 'End weigh-in?\n\n{ready} ready, {notReady} not ready → WO',
    // #552 — the trash of the Bout Preview header and its confirm: one verb, one noun.
    discardPlanConfirm: 'Delete the draft plan?',
    discardPlan: 'Delete draft plan',
    moveBoutPrompt: 'Move bout {n} to position:', moveBout: 'Move',
    // #556 — count forms (countLabel): "1 bout", "2 bouts".
    officialsAssignedOne: 'Officials assigned for {n} bout', officialsAssignedFew: 'Officials assigned for {n} bouts', officialsAssignedOther: 'Officials assigned for {n} bouts',
    cannotPlaceReferee: 'Cannot place — referee already on this bout',
    createChallengeBoutsConfirm: 'Create {n} challenge bouts?',
    saveReassignConfirm: 'Save bout reassignments?',
    createAllBoutsConfirm: 'Create all bouts? Tournament will be locked.',
    // #552 — texts that the tournament tabs held in English.
    juryAssignTitle: 'Jury Assignment',
    juryAssignHint: 'Open a bout that has no jury. Then click "Claim as Jury" on the bout page.',
    // #615 — the jury outside the referee pool: the notice of the Bouts tab.
    joinPoolFirst: 'Join the referee pool first', joinPoolFirstHint: 'Go to the Officials tab and join the pool.',
    bracketScheduled: 'Scheduled',
    removeManager: 'Remove manager',
    ratingsEmptyTitle: 'No medals yet',
    ratingsEmptyHint: 'The team ratings count the bracket medals. The table shows after the first medal.',
    selectDay: 'Select a day',
    selectDayHint: 'Select a day to show the boxers of that weigh-in.',
  },
  teams: {
    wantsToJoinAsAthlete: 'Wants to join as athlete', currentlyIn: '(currently in {team})',
    teamName: 'Team name', createTeam: 'Create Team', editTeam: 'Edit Team', deleteTeamConfirm: 'Delete "{name}"? This cannot be undone.', teamDeleted: 'Team deleted', teamUpdated: 'Team updated',
    // #552 — a short tab label: three tabs must fit a 360 px phone.
    members: 'Members',
    athletes: 'Athletes',
    joinTeam: 'Join this Team',
    joinAsAthlete: 'Join as Athlete', joinAsCoach: 'Join as Coach',
    claimRecord: 'Claim a Record', claimHelp: 'If a coach added you before you registered, find and claim your athlete record here.',
    facebookPage: 'Facebook Page',
    addAthleteRecord: 'Add Athlete Record',
    noMembers: 'No members yet', noTeams: 'No teams yet', noTeamsMatch: 'No team matches the filters.', // #661
    coaches: 'Coaches',
    unmanaged: 'Unmanaged', claimAsHeadCoach: 'Claim as Head Coach',
    // #552 — the title and the aria-label of the pencil icon button: no glyph.
    editDetails: 'Edit details', changeLogo: 'Change logo', removeLogo: 'Remove logo',
    noPendingRequests: 'No pending requests', noUnclaimedRecords: 'No unclaimed records in this team',
    claimsPending: 'Claim pending', claimedBy: 'Claimed by',
    wantsToJoinAs: 'wants to join as', joinAsNewMember: 'Join as a new member',
    requestToJoin: 'Request to join', headCoachReview: 'The Head Coach will review and approve.',
    thisIsMe: 'This is me',
    // #569 — the claim dialog asks for the birth date of the athlete record.
    claimTitle: 'Claim the athlete record', sendClaim: 'Send the claim',
    claimBirthDateHelp: 'Enter your birth date. After 3 wrong birth dates, wait 24 hours. You can also ask your coach to check the athlete record.',
    birthDateMatched: 'The birth date matched', birthDateNotChecked: 'The birth date was not checked',
    rivalClaim: 'Another person claims this record too',
    removeLogoConfirm: 'Remove team logo?',
    assignCoach: 'Assign Coach', assignRole: 'Role', searchUser: 'Search user',
    searchTeams: 'Search by name or location...', allLocations: 'All locations', unclaimed: 'Unclaimed', claimed: 'Claimed', requests: 'Requests', federationMember: 'Federation Member',
    unlink: 'Unlink', unlinkFromUserAccount: 'Unlink from user account', unlinkConfirm: 'Unlink {name} from their user account? The record will become unclaimed.', removedFromTeam: '{name} removed from team',
    removeFromTeam: 'Remove from team', removeCoachConfirm: 'Remove {name} from {team}?', promoted: '{name} promoted to Head Coach', demoted: '{name} demoted to Coach',
    // #597 (operator, 2026-10-11): a team has one Head Coach, so a promote hands the role over.
    promoteHandsOver: 'A team has one Head Coach. If the team has a Head Coach, that Head Coach becomes a Coach.',
    promotedHandover: '{name} is the Head Coach now. The previous Head Coach is a Coach.',
    archive: 'Archive', archiveConfirm: 'Archive {name}? Their bouts history is preserved and the record can be restored later.', archived: '{name} archived',
    restore: 'Restore', restoreConfirm: 'Restore {name}? They will appear again in active rosters.', restored: '{name} restored',
    removeAthleteConfirm: 'Remove {name} from {team}? The athlete keeps the bout history and stays in the Athletes list. Another team can invite the athlete.',
    // #658 — a coach invites an athlete of another team or of no team.
    invite: {
      button: 'Invite an athlete', title: 'Invite an athlete',
      hint: 'The athlete approves the invitation. For an athlete with no account, an admin or a team manager approves it.',
      search: 'Search by name', noMatch: 'No athlete found', noTeam: 'No team',
      send: 'Send invitation', sent: 'Invitation sent to {name}',
    },
    // #658 — the create form found the record of the same person.
    existing: {
      found: 'This athlete is already in LMF:', invite: 'Invite to this team',
      sameTeam: 'The athlete is already in this team.',
      claim: 'If this is you, claim the record.',
      archivedFound: 'An archived record of this athlete exists. Ask an admin to restore it.',
    },
    showArchived: 'Show archived', archivedBadge: 'archived',
    // #458 — toasts that the code held in English.
    teamCreated: 'Team created', joinRequestSentCoach: 'Join request sent as coach',
    memberApproved: 'Member approved', memberRejected: 'Member rejected',
    recordAdded: 'Athlete record added',
    claimApproved: 'Claim approved', claimRejected: 'Claim rejected',
    athleteRequestApproved: 'Athlete request approved', athleteRequestRejected: 'Athlete request rejected',
    selfClaimSubmitted: 'Claim request submitted — awaiting coach approval',
    teamClaimSubmitted: 'Claim submitted — awaiting approval',
    assignedHeadCoach: '{name} assigned as head coach', assignedCoach: '{name} assigned as coach',
    logoUpdated: 'Logo updated', logoRemoved: 'Logo removed',
    athleteUpdated: '{name} updated', unlinked: '{name} unlinked',
    requestSentTo: 'Request sent to {team}',
    profileCreatedRequestSent: 'Athlete profile created. Request sent to {team}',
    // #552 — the counts of the team list, through countLabel().
    membersOne: '{n} member', membersFew: '{n} members', membersOther: '{n} members',
    teamsOne: '{n} team', teamsFew: '{n} teams', teamsOther: '{n} teams',
    locationsOne: '{n} location', locationsFew: '{n} locations', locationsOther: '{n} locations',
  },
  profile: {
    myProfile: 'My Profile', requestRole: 'Request Role', signOut: 'Sign out',
    // #658 — a coach invites the athlete to a team.
    teamInvites: { title: 'Team invitations', invites: '{team} invites you to join the team.', approved: 'You joined {team}', rejected: 'You rejected the invitation of {team}' },
    // #664 — the note under the invitations: the join request of the athlete waits for a coach.
    pendingJoinRequest: 'Pending join request to {team}. A coach must approve it.',
    firstName: 'First name', lastName: 'Last name', birthDate: 'Birth date',
    experienceBouts: 'Experience (bouts)', currentWeight: 'Current weight (kg)',
    phone: 'Phone number', facebookUrl: 'Facebook profile',
    saved: 'Profile saved', saveProfile: 'Save profile',
    noAthleteProfile: "You don't have an athlete profile yet",
    browseTeams: 'Browse teams',
    // #655 — a user asks for two roles only. An admin gives every other role.
    roleRequestHelp: 'You can request the Athlete role or the Head Coach role here. An admin gives the other roles.',
    athleteRoleHelp: 'Compete in bouts. Your coach registers you for tournaments. You get this role at once.',
    headCoachRoleHelp: 'Create and manage a team. Register athletes for tournaments. An admin approves the request.',
    requestButton: 'Request',
    notePlaceholder: 'For example: I am a coach at Vilnius Gym',
    noteForAdmin: 'Note for admin (optional)',
    alreadyHave: 'You have this role',
    pendingApproval: 'Pending approval',
    rejected: 'Rejected',
    // #655 — the status of a row in the request history: the raw code showed.
    approved: 'Approved',
    requestHistory: 'Request history',
    // #458 — toasts and a confirm text that the code held in English.
    roleRequested: 'Request for {role} submitted',
    photoUpdated: 'Photo updated', photoRemoved: 'Photo removed',
    removePhotoConfirm: 'Remove your profile photo?',
    removePhoto: 'Remove photo',
    // #552 — the avatar button: the title held English.
    changePhoto: 'Change photo',
  },
  roles: {
    // #531 — every role, for roleLabel(): the raw id showed in English.
    admin: 'Admin', tournament_manager: 'Tournament Manager', team_manager: 'Team Manager',
    head_coach: 'Head Coach', coach: 'Coach', athlete: 'Athlete', referee: 'Referee', jury: 'Jury',
    // #557 — the seats of an official on a bout, for the notices of the officials.
    // `judge` is a side judge (a `bout_referees` row): the same term as the bout page.
    ring_referee: 'Ring Referee', judge: 'Side Judge',
  },
  scoring: {
    // #469 — the card follows IFMA v3.057 §29.2.3 and §29.2.5.
    pointsRange: 'Score the round as fought: 10 to the better boxer, 9–7 to the other. Each Warning takes 1 point.',
    cornerPoints: '{corner} — Points',
    warningsHint: 'Each Warning takes 1 point',
    roundOutcome: 'Round outcome',
    even: 'Even',
    wonRound: '{corner} won the round {score}',
    evenRound: 'Even round 10–10',
    warningDeduction: '{corner}: −{n} (Warnings)',
    afterWarnings: 'Points after the Warnings',
    submitRound: 'Submit Round {n}',
    updateRound: 'Update Round {n}',
    savedHint: 'Round {n} saved — you can still update it.',
    savedToast: 'Round {n}: {red}–{blue} saved',
    approvedTitle: 'Round {n} — approved by the jury',
    approvedText: 'The jury locked this round. Your card is below, and you cannot change it.',
    notSubmitted: 'You did not submit a card for this round before the jury approved it.',
    // The outcome disagrees with the points: say what to change (#469).
    mismatchEven: '10–10 is an even round. If {corner} won the round, give the other boxer 9 or less.',
    mismatchNeedsEven: 'An even round is 10–10. Give both boxers 10.',
    mismatchCorner: 'The points give the round to {derived}. If {corner} won the round, give the other boxer 9 or less.',
  },
  admin: {
    editUser: 'Edit user', requestedOn: 'Requested {date}', noRoles: 'No roles',
    roleRequests: 'Role Requests', teamClaims: 'Team Claims', coachJoins: 'Coach Joins', athleteJoins: 'Athlete Joins',
    searchAudit: 'Search by email, name, or values...', allTables: 'All tables', allRoles: 'All roles',
    // #552 — the titles of the user modals, and the labels of the audit
    // detail modal; they held English. auditDetailAria keeps the old name.
    createUserTitle: 'Create User', editUserTitle: 'Edit User', roles: 'Roles',
    auditDetailAria: 'Details of the audit log entry',
    auditBy: 'By', auditWhen: 'When', auditIp: 'IP', auditRow: 'Row', auditRowId: 'Row ID',
    auditChanges: 'Changes', auditValues: 'Values', auditCreatedValues: 'Created values', auditDeletedValues: 'Deleted values',
    editUserNote: 'Identity, sign-in and roles only. The athlete data (gender, date of birth, weight, experience) is on the athlete profile.',
    // #376 — the merged Requests queue and the athlete record claims.
    requestKinds: {
      all: 'All',
      role: 'Role',
      teamClaim: 'Team claim',
      member: 'Coach join',
      athleteJoin: 'Athlete join',
      athleteClaim: 'Athlete claim',
      athleteInvite: 'Team invitation',
      wantsRole: 'Requests the role',
      claimsTeam: 'Claims the team',
      joinsTeam: 'Asks to join',
      joinsAsAthlete: 'Asks to join as athlete:',
      claimsRecord: 'Claims the athlete record of',
      invitedTo: 'Has no account. Invited to',
      noTeam: 'no team',
      emptyTitle: 'No pending requests',
      emptyClaims: 'No pending athlete record claims',
      // #664 — the empty title of the other three lists.
      emptyTeamClaims: 'No pending team claims',
      emptyMembers: 'No pending coach joins',
      emptyAthleteJoins: 'No pending athlete joins',
    },
    // #661 — the title of the empty list of role requests, for each status filter.
    noRequestsByStatus: { pending: 'No pending requests', approved: 'No approved requests', rejected: 'No rejected requests', all: 'No requests' },
    panelTitle: 'Admin Panel',
    eraseUser: 'Delete account',
    eraseUserHint: 'Erases the account, its sign-in, email, phone and photo. The athlete record stays, unclaimed. An official who judged a bout keeps their name on the result; only their account is erased. This cannot be undone.',
    eraseConfirm1: 'Delete this account permanently?',
    eraseConfirm2: 'Last check: the account, its sign-in and contact details are erased. Athlete records and results stay. Continue?',
    userErased: 'Account erased',
    eraseFailed: 'The account was not erased',
    users: 'Users',
    requests: 'Requests', auditLog: 'Audit Log',
    // #503 — the refresh filter of the audit log.
    auditHideRefreshes: 'Hide session refreshes',
    // #664 — the pager of the audit log and the badge of a user with no sign-in method.
    pagePrev: 'Previous', pageNext: 'Next', pageOf: 'Page {n} of {m}',
    noSignIn: 'No sign-in method',
    searchUsers: 'Search by name or email...',
    // #458 — toasts and a prompt text that the code held in English.
    athleteClaimApproved: 'Athlete claim approved', athleteClaimRejected: 'Athlete claim rejected',
    athleteRequestApproved: 'Athlete request approved', athleteRequestRejected: 'Athlete request rejected',
    athleteInviteApproved: 'Team invitation approved', athleteInviteRejected: 'Team invitation rejected',
    memberApproved: 'Member approved', memberRejected: 'Member rejected',
    teamClaimApproved: 'Team claim approved', teamClaimRejected: 'Team claim rejected',
    requestApproved: 'Request approved', requestRejected: 'Request rejected',
    pingDefault: 'Attention needed',
    // #664 (F40) — the bell of a user row. The toast of a sent ping is t.tournament.notificationSent (PingModal).
    notifyUser: 'Send a notification to {name}',
    userUpdated: 'User updated', userCreated: 'User created: {email}',
    // #552 — the date of a resolved role request, and the paging of the user list.
    resolvedOn: 'Resolved {date}',
    showMore: 'Show more ({shown} of {total})',
    // #552 — the badge beside the page title: it held English.
    adminOnly: 'Admin only',
  },
  home: {
    title: 'Lithuanian Muaythai Federation',
    subtitle: 'Live scoring, brackets, and results for every federation event.',
    signInToContinue: 'Sign in to continue',
    today: 'Today',
    upcoming: 'Upcoming Events',
    recent: 'Recent Events',
    viewAll: 'View all',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    continueGoogle: 'Continue with Google',
    email: 'Email',
    password: 'Password',
    createAccount: 'Create your account',
    alreadyHaveAccount: 'Already have an account?',
    // #529 — the notice at collection (GDPR Art. 13); the link opens /manual#privacy.
    privacyNotice: 'Lietuvos muaythai federacija uses your personal data to organize tournaments. More information:',
    privacyLink: 'Personal data (GDPR)',
    // #584 — the link opens /manual#terms.
    termsNotice: 'The use of the app follows the terms. More information:',
    termsLink: 'Terms of service',
    orDivider: 'or',
    confirmPassword: 'Confirm password',
    forgotPasswordLink: 'Forgot password?',
    forgotPassword: 'Reset Password',
    forgotPasswordHint: "Enter your email and we'll send you a reset link.",
    sendResetLink: 'Send Reset Link',
    resetLinkSent: 'If an account with that email exists, a password reset link has been sent. Check your inbox.',
    newPassword: 'New Password',
    resetPassword: 'Reset Password',
    passwordRequirements: 'Min 8 characters, uppercase, lowercase, digit',
    passwordsMismatch: 'Passwords do not match.',
    passwordResetSuccess: 'Your password has been reset. You can now sign in.',
    invalidResetLink: 'Invalid or missing reset link.',
    requestNewLink: 'Request a new link',
  },
  // #616 — the statistics of the officials.
  officials: {
    title: 'Officials', countHint: 'Scored bouts only. A Walk Over does not count.',
    noOfficials: 'No officials yet.', searchPlaceholder: 'Search by name',
    tournaments: 'Tournaments', history: 'Bouts', noBouts: 'No counted bouts yet.',
    myStats: 'My statistics as an official', sortBy: 'Sort by',
    summary: 'Summary', summaryTitle: 'The officials of the tournament', done: 'Done', todo: 'To do',
    // #647 — the report of the officials of a tournament (the views of the Summary modal).
    reportLoad: 'Load', reportQuality: 'Quality', reportReview: 'Bouts to review', reportCoverage: 'Coverage',
    reportQualityHint: 'The numbers of this tournament only. Under each number: all the judges of the tournament. A small number of cards gives a rough rate.',
    reportAllJudges: 'All judges of the tournament',
    reviewHint: 'The scored bouts that need a second look. Each bout shows its reasons.',
    reviewNone: 'No bout to review.', pillSplit: 'Split cards',
    coverageHint: 'The Pro and High bouts of the tournament that are not a Walk Over, and their ring referees.',
    coverageIfma: 'IFMA ring referee', coverageNovice: 'Novice ring referee', coverageOther: 'Other ring referee', coverageNoRef: 'No ring referee', coverageBouts: 'Bouts: {list}',
    neutralityTitle: 'Bouts with neutral officials', neutralityValue: '{n} of {m}',
    neutralityHint: 'A scored bout where no ring referee and no side judge belongs to the team of a boxer.',
    noSeats: 'No official has a seat yet.', noDay: 'No day', noMatch: 'No official matches the search.',
    // Phase 2: the quality numbers (an admin, a tournament manager and the jury).
    quality: 'Quality', qualityHint: 'An admin, a tournament manager and the jury see these numbers.',
    agreement: 'Agreement with the jury', agreementShort: 'Agreement',
    agreementHelp: 'A card agrees when its round outcome is the outcome of the round that the jury approved. With no jury total, the jury approved the suggestion of the cards. The rate shows from 30 compared cards.',
    // #641 — the panel and the jury.
    panelAgreement: 'Agreement with the panel',
    panelAgreementHelp: 'The panel is the cards of a round with 3 or more cards. A card agrees when its round outcome is the outcome of more than half of the cards. A round with no such outcome does not count. The rate shows from 30 compared cards.',
    juryPanel: 'Decisions against the panel',
    juryPanelHelp: 'The jury decision is not the outcome of more than half of the cards: the approved round outcome, or the winner of a WP bout.',
    juryPanelDetail: 'Rounds: {a} of {b} · WP bouts: {c} of {d}',
    panelJuryTitle: 'The panel and the jury',
    panelJuryHint: 'Each card against the panel (more than half of the cards) and against the jury decision. A dissent upheld is a card against the panel that the jury agrees with. A WP bout counts when the side judge scored each approved round. The card of the bout is then the total of its points.',
    panelRounds: 'Rounds', panelBouts: 'WP bouts', panelCardsOne: '{n} card', panelCardsFew: '{n} cards', panelCardsOther: '{n} cards',
    withPanel: 'With the panel', againstPanel: 'Against the panel', withJury: 'With the jury', againstJury: 'Against the jury',
    dropped: 'Dropped cards', droppedHelp: 'In a round with 4 or 5 cards: the card was the only lowest or the only highest.',
    stoppages: 'Stoppages (KO, RSC)', stoppagesShort: 'Stoppages', stoppagesHelp: 'Bouts as ring referee that ended by KO or RSC.',
    juryTotals: 'Jury totals that differ', juryTotalsHelp: 'Approved rounds where the jury typed totals other than the suggestion of the cards.',
    ofTotal: '{a} of {b}', noData: 'No data',
    // #622 — the level of the bouts of an official.
    levelTitle: 'Level of the bouts',
    levelHint: 'The experience of the boxers decides, in each age class (LMF rules). Pro: both boxers have 10 or more bouts. High: one boxer has 10 or more bouts. Medium: the more experienced boxer has 5 to 9 bouts, or another adult bout. Low: both boxers have fewer than 5 bouts (U18 and younger).',
    levelEstimates: '≈ Estimated levels: {n} of {m}. These bouts came before the registration recorded the experience.',
    levelUnknown: 'No level: {n}',
    colLevels: 'Pro · High · Medium · Low', sortHigh: 'Pro and High bouts', proPill: 'Pro bouts: {n}', highPill: 'High bouts: {n}',
    // #620 — the statistics over time.
    overTime: 'Over time',
    overTimeHint: 'One row for each tournament, newest first. A trend compares the last 3 tournaments with up to 3 tournaments before them (LMF rules). Each group of tournaments needs at least 30 rounds.',
    overTimeHintCounts: 'One row for each tournament, newest first.',
    colTournament: 'Tournament',
    trendUp: 'Up', trendDown: 'Down', trendSteady: 'Steady',
    trendLast: 'Last 3 tournaments: {pct}', trendBefore: 'Before: {pct}',
    trendBetter: 'better', trendWorse: 'worse',
    roundsOne: '{n} round', roundsFew: '{n} rounds', roundsOther: '{n} rounds',
    tooFewRounds: 'Too few rounds for a trend',
    allJudges: 'All judges: {pct}', allJuries: 'All juries: {pct}',
    chartTitle: 'Agreement at each tournament', chartOfficial: 'This official', chartField: 'All judges',
    chartAria: '{title}: this official from {from} to {to}; all judges from {fieldFrom} to {fieldTo}',
    // #641, #642 — the profile of an official (the team history, the IFMA accreditation, the novice status).
    profileTitle: 'Profile',
    profileHint: 'An admin, a tournament manager and the jury see the profile and change the profile of another official. Only an admin changes the own profile.',
    teamLabel: 'Team', noTeam: 'No team', changeTeam: 'Change team', fromDate: 'From {date}',
    teamModalTitle: 'Change the Team', fromLabel: 'From', untilLabel: 'Until', untilOptional: 'Until (empty: no end)',
    teamPeriodHint: 'A new period starts on this date. The tournaments before this date keep the earlier team.',
    removePeriod: 'Delete the period', removePeriodTitle: 'Delete the Team Period',
    accreditationLabel: 'IFMA accreditation', accredited: 'Accredited', notAccredited: 'Not accredited',
    addAccreditation: 'Add Accreditation', noEnd: 'no end', endAccreditation: 'End', endAccreditationTitle: 'End the Accreditation',
    removeAccreditation: 'Delete the accreditation', removeAccreditationTitle: 'Delete the Accreditation',
    removeQuestion: 'Delete this row? Do this only for a typing mistake. A move is a new period. An accreditation that lapsed gets an end.',
    removeSure: 'You cannot undo the delete. Delete the row?',
    seatSideJudge: 'Side judge', seatRingReferee: 'Ring referee',
    experienced: 'Experienced', novice: 'Novice', experiencedIfma: 'Experienced (IFMA accreditation)',
    seatBouts: '{bouts} in 24 months', seatHard: '{n} at the Medium, High or Pro level', seatLast: 'last seat on {date}', seatNoSeat: 'no seat in 24 months',
    noviceRule: 'The app computes the novice status for each seat on the first day of each tournament. Side judge: 30 bouts in 24 months, and a side-judge seat in the last 12 months. Ring referee: 20 bouts in 24 months, 10 of them at the Medium, High or Pro level, and a ring-referee seat in the last 12 months. An IFMA accreditation makes an official experienced.',
    // #641 — the own-team cards.
    ownTeamTitle: 'Own team',
    ownTeamHint: 'A card of a round where a boxer of the team of the judge is in one corner. The app compares the card with the jury decision (the approved round, or the winner of a WP bout) from the side of that corner. A card that agrees with the jury shows no bias. A card for the own corner and a card against it both differ from the jury, and both count.',
    forOwn: 'For the own corner', againstOwn: 'Against the own corner',
    ownTeamReference: 'Own-team rounds: against the jury in {n} of {m}. Other rounds: against the jury in {a} of {b}.',
    // #644 — the panel and the own-team cards in the "Over time" section.
    colPanel: 'With the panel', colOwnTeam: 'Own team: against the jury', cellOwnSplit: 'for {for} · against {against}', cellUpheld: 'Dissent upheld: {n}',
    ownTeamChartTitle: 'Own-team rounds against the jury at each tournament',
    ownTeamChartHint: 'Each point counts the own-team rounds of one tournament where the card of the judge differs from the jury decision. A card for the own corner and a card against it both count. A tournament with no such round is 0.',
    ownTeamChartLine: 'Against the jury',
    ownTeamChartTotals: 'All tournaments: {n} of {m} own-team rounds (for the own corner {for}, against the own corner {against})',
    ownTeamChartAria: '{title}: against the jury in {n} of {m} own-team rounds, for the own corner {for}, against the own corner {against}',
    ownTeamPoint: '{date} · {name}: against the jury in {n} of {m} own-team rounds (for the own corner {for}, against the own corner {against})',
    // #631 — the disagreement marks of the bout rows (canSeeAllOfficialStats).
    pillCard: 'Card gives: {corner}', pillRounds: 'Other round outcome: {rounds}',
    pillDropped: 'Dropped card: {rounds}', pillJury: 'Jury total differs: {rounds}',
    // #641 — {what} lists the rounds and the bout.
    pillDissentUpheld: 'Dissent upheld: {what}', pillAgainstPanel: 'Against the panel: {what}',
    pillBout: 'bout', pillJuryTotalRound: '{round} (jury total)',
    pillOwnTeam: 'Own team: {corner}', pillForOwn: 'For the own corner: {what}', pillAgainstOwn: 'Against the own corner: {what}',
    pillsHint: 'The marks of each bout. Card gives: in a WP bout, the side judge scored each approved round. The total of the card gives the win to the corner that lost by the verdict. Other round outcome: the card does not agree with the approved round. Dropped card: in a round with 4 or 5 cards, the card was the only lowest or the only highest. Jury total differs: the jury typed totals other than the suggestion of the cards. Dissent upheld: the card is against the panel, and the jury agrees with the card. Against the panel: the jury decision is not the outcome of more than half of the cards. Own team: a boxer of the team of the judge is in that corner. For the own corner: the card is better for that corner than the jury decision. Against the own corner: the card is worse for that corner than the jury decision. A bout with none of these marks has no disagreement, or has no data.',
  },
  athletes: {
    noAthletes: 'No athletes found',
    // #595, #199 — the athlete page: the bouts and the record. Winner and Draw are t.common.
    history: 'Bouts', noBouts: 'No bouts yet.', won: 'Won', lost: 'Lost',
    // #615 — the experience pill: the bouts before LMF and the verdicts in LMF.
    experiencePill: 'Experience: {n}',
    // #198 — the medals of the athlete.
    gold: 'Gold', silver: 'Silver', bronze: 'Bronze',
    reassignTeam: 'Reassign Team', newTeam: 'New Team', selectTeam: 'Select team',
    // #552 — the name of the dialog. modal-a11y.spec.ts pins the English exactly.
    reassignAria: 'Reassign athlete to team',
    currentTeam: 'Current', reassign: 'Reassign',
    // #552 — the paging of the athlete list.
    showMore: 'Show more ({shown} of {total})',
    // #578 — merge two records of one person (staff only).
    merge: {
      action: 'Merge into another record',
      title: 'Merge Two Records',
      aria: 'Merge two athlete records',
      search: 'Search the other record of this person...',
      noMatch: 'No other record matches.',
      thisRecord: 'This record', otherRecord: 'Other record', keep: 'Keep',
      name: 'Name', birthDate: 'Birth date', gender: 'Gender', team: 'Team', status: 'Status',
      active: 'Active', archived: 'Archived', experience: 'Experience',
      moves: 'Moves to the kept record',
      registrations: 'Registrations: {n}', bouts: 'Bouts: {n}', seeds: 'Bracket seeds: {n}',
      requests: 'Claims and team requests: {n}', accountLink: 'The account link',
      checking: 'Checking...',
      warning: 'The other record is deleted. You cannot undo a merge.',
      confirm: 'Merge',
    },
  },
  login: {
  },
  register: {
    title: 'Create Account',
  },
  auth: {
    checkEmail: 'Check your email', verificationSent: 'We sent a verification link to',
    resendLink: 'Resend verification email', backToLogin: 'Back to sign in',
    // #605 — the screen after a resend that worked.
    verificationResent: 'We sent a new verification link. Check your email.',
    emailVerified: 'Email verified!', canNowLogin: 'Your account is ready. Sign in to continue.',
    verificationFailed: 'Verification failed',
    // #664 — the two texts of the auth pages that the code held as English literals.
    noVerificationToken: 'The verification link has no token.',
    signingIn: 'Sign-in in progress…',
  },
  bulkReg: {
    title: 'Register Boxers',
    stepTeam: 'Team', stepAthletes: 'Athletes', stepReview: 'Review',
    whichTeam: 'Which team are you registering athletes from?',
    searchAthletes: 'Search athletes...', newAthlete: '+ New athlete',
    loading: 'Loading athletes...', selectAll: 'Select all available',
    ageGroup: 'Age group', weightClass: 'Weight class', currentWeight: 'Current weight',
    derivedFromBirth: 'Derived from birth date', suggestedFromWeight: 'Suggested from weight',
    needsBirthDate: 'Needs birth date', noClassesFound: 'No classes found', noAgeGroup: 'No age group',
    required: 'Required', edit: 'Edit', registered: 'Registered', unregistered: 'unregistered',
    noAthletesFound: 'No athletes found',
    confirmFor: 'Confirm registrations for', athlete: 'Athlete',
    missingFields: 'Some athletes are missing a weight class or birth date. Go back and complete them.',
    // The result of Register Boxers is one toast with the numbers (2026-09-25).
    registeredCount: '{n} boxer(s) registered',
    registeredPartly: '{ok} boxer(s) registered, {failed} athlete(s) not registered. The list shows the reason.',
    noneRegistered: '{failed} athlete(s) not registered. The list shows the reason.',
    selected: 'selected', registering: 'Registering', register: 'Register',
    back: 'Back', next: 'Next', review: 'Review', cancel: 'Cancel',
    submitting: 'Registering...',
    newAthleteTitle: 'New athlete record',
    newAthleteDesc: 'Creates an unregistered athlete record in',
    newAthleteNote: 'The athlete can claim this record later via the Teams page once they have an app account.',
    genderRequired: 'First name, last name, gender and date of birth are required.',
    ageOutOfRange: 'Age is outside supported IFMA age groups (4–65).',
    ageGroupNotTaken: 'This tournament does not take the age group {ageGroup}.',
    createFailed: 'Failed to create athlete record.',
    creating: 'Creating...', createAndAdd: 'Create & add to list',
    unregister: 'Unregister', unregisterConfirm: 'Unregister',
    // #458 — the weight toast that the code held as a literal.
    weightSaved: '{name} → {weight} kg',
    // #608 — a weight class shows as its label, "-71", with no unit.
    weightClassSaved: '{name} → {weightClass}',
    // #674 — the toast after a saved bout count. {bouts} is the count with its unit, "7 bouts".
    experienceSaved: '{name} → {bouts}',
  },
  // #480 — the Bout Plan window and its analysis. The numbers come from the
  // server (lib/planAnalysis.ts). Stage names come from stageLabel().
  planAnalysis: {
    open: 'Analysis',
    title: 'Bout plan analysis',
    subtitle: '{bouts} bouts · {days} day(s)',
    tabOverview: 'Overview', tabByDay: 'By day and ring', tabRest: 'Rest', tabIfma: 'IFMA checks', tabFlags: 'Flags',
    cardBouts: 'Bouts', cardShortRest: 'Rest under {min} min', cardDrawOrder: 'Draw order breaks',
    cardContests: 'Most bouts in a day', cardRingFit: 'Bouts on a ring that does not fit', cardImbalance: 'Largest ring gap in a day',
    ringTotals: 'Ring totals', topFlags: 'Top flags', moreFlags: '+ {n} more in the Flags tab',
    startTime: 'Start time', startTimeHint: 'Enter a start time to see clock times. The time is not saved.',
    ringBouts: '{n} bouts', ringSpan: '{start} → {end}',
    balanced: 'Balanced ({gap} gap)', gapLast: '{gap} gap: {ring} finishes last',
    boutTimes: 'Bout start times', noDates: 'No bout has a date.',
    colFrom: 'From', colTo: 'To', colClass: 'Class', colRing: 'Ring', colRest: 'Rest',
    restMinutes: '~{n} min', overnight: 'another day', noRest: 'no rest',
    statusOk: 'OK', statusShort: 'Short', statusNone: 'None',
    restRule: 'IFMA v3.057 §16.4.1: at least {min} minutes between two bouts of one boxer on one day. The rest counts from the end of one bout to the start of the next, on the clock of each ring. The rings start together.',
    noDependencies: 'No bout in this plan waits for a winner.',
    contestsTitle: 'Bouts in a day (§16.4)',
    contestsRule: 'IFMA allows one bout a day. More needs a special decision, and never more than 3 (§16.4.2).',
    contestsRow: '{label} · {date}: {n} bouts for a boxer who wins through',
    contestsNone: 'No class has more than one bout in a day.',
    drawTitle: 'Draw order (§16.1, §16.2)',
    drawRule161: 'Bout #{a} ({label}) starts before bout #{b} ends: a winner competes again before every boxer has competed once (§16.1).',
    drawRule162: 'Bout #{a} ({label}) starts before bout #{b}: the bye boxers compete first in their series (§16.2).',
    drawNone: 'The plan keeps the IFMA draw order.',
    ringFitTitle: 'Ring fit',
    ringFitRow: 'Bout #{n} ({label}) is on {ring}, and {ring} does not fit this class.',
    ringFitNone: 'Every bout is on a ring that fits its class.',
    flagNoRest: '{n} bout(s) give the winner of the earlier bout no rest: {list}.',
    flagShortRest: '{n} rest(s) under {min} min: {list}.',
    flagDrawOrder: '{n} break(s) of the IFMA draw order: see the IFMA checks tab.',
    flagContestsOver: '{n} class day(s) with more than 3 bouts (§16.4.2): {list}.',
    flagContestsMany: '{n} class day(s) with 2 or 3 bouts (§16.4): {list}.',
    flagRingFit: '{n} bout(s) on a ring that does not fit the class: {list}.',
    flagImbalance: '{date}: {ring} finishes {gap} after {other}.',
    flagUnusedRings: 'These rings have no bouts: {list}.',
    flagNone: 'No issues found.',
    breakTitle: 'IFMA requires {min} min rest. Schedule a break before this bout.',
    restUnknown: 'not measured', restUnknownTitle: 'This bout or the bout before it has no ring or no date.',
    statusUnknown: 'Not measured',
    flagUnmeasured: '{n} bout(s) have no ring or no date, so their rest and order are not measured: {list}.',
    ringNotFit: 'The ring does not fit this class',
  },
  checkin: {
    pending: 'pending', ready: 'ready', absent: 'absent', resetFailed: 'The reset failed', readyFailed: 'The Ready action failed',
    // #531 — a count takes the plural form of the language (countLabel).
    athletesOne: '{n} athlete', athletesFew: '{n} athletes', athletesOther: '{n} athletes',
    readyOne: '{n} ready', readyFew: '{n} ready', readyOther: '{n} ready',
    searchPlaceholder: 'Search by name or team...',
    athlete: 'Boxer', confirmed: 'Confirmed', ageGroup: 'Age Group',
    weightClass: 'Weight Class', actualWeight: 'Actual Weight', status: 'Status', actions: 'Actions',
    noMatch: 'No boxers match your search.', noRegistrations: 'No registrations yet.',
    readyBtn: 'Ready', absentBtn: 'Absent', resetBtn: 'Reset', saveBtn: 'Save',
    enterWeight: 'Enter the actual weight first.', markReady: 'Mark as ready',
    saveTitle: 'Save class / confirmed changes only',
    wasLabel: 'was', feesMedical: 'Fees paid + medical cleared',
    yrs: 'yrs',
    endCheckinBtn: 'End Check-in', endCheckinConfirm: 'End the check-in? Every pending boxer becomes absent. A bout with one absent boxer ends by Walk Over. Registration locks.',
    registrationLockedNotice: 'Registration is locked. "Ready" and "Reset" are off. Unlock registration to change a check-in.',
    boutsLockedNotice: 'The bout list is locked. "Ready" and "Reset" are off. Unlock the bout list to change a check-in.',
    hint: '"Ready" requires an actual weight. Use "Reset" to undo a mark. "End Check-in" marks all remaining as absent.',
    // #536 — an athlete in a bracket (a hybrid tournament): the desk keeps the class.
    inBracket: 'Bracket',
    inBracketTitle: 'In a bracket: the desk cannot change the weight class.',
    limitUnknown: 'The weight classes did not load, so the desk cannot check the limit. Reload the page, then weigh the boxer.',
    // #547 — the desk sets the class from the weight; without the list it cannot.
    classUnknown: 'The weight classes did not load, so the desk cannot set the class. Reload the page, then weigh the boxer.',
    // #547 — the Check-in desk serves an open ring and a hybrid: no automatic
    // walk-over there. The manager decides for an athlete over the limit.
    overBracketConfirm: 'The weight {weight} kg is over the limit of {limit} kg. The boxer is in a bracket, so the class cannot change. Mark the boxer ready in this class?',
    overBracketLimit: 'Not marked: {weight} kg is over the limit of {limit} kg. A boxer in a bracket keeps the class. Click "Ready" again to mark the boxer ready in the class. A pending boxer becomes absent at End Check-in.',
    // #547 — an athlete with a bout (and no bracket) keeps the class too: the bout
    // carries it (ATHLETE_ASSIGNED_TO_BOUT).
    overBoutConfirm: 'The weight {weight} kg is over the limit of {limit} kg. The boxer has a bout, so the class cannot change. Mark the boxer ready in this class?',
    overBoutLimit: 'Not marked: {weight} kg is over the limit of {limit} kg. A boxer with a bout keeps the class. Click "Ready" again to mark the boxer ready in the class. A pending boxer becomes absent at End Check-in.',
  },
  // #548, #549 — the Weigh-in tab of a championship. The athlete stays in the
  // registered class, or the bout is a Walk Over. End Weigh-in needs two people.
  weighin: {
    lockedFirst: 'Lock the bout list first. Then this tab shows the boxers of each day.',
    filterPlaceholder: 'Search by name or team...',
    notReadyOne: '{n} not ready', notReadyFew: '{n} not ready', notReadyOther: '{n} not ready',
    noAthletes: 'No boxer has a bout on this day.',
    weightLabel: 'Actual weight in kg',
    weightPlaceholder: 'kg',
    markReady: 'Mark the boxer ready',
    markNotReady: 'Mark the boxer not ready',
    weightFirst: 'Enter the actual weight first.',
    overBadge: '+{over} kg',
    overBadgeTitle: 'Over the limit of the class: {limit} kg',
    overLimitConfirm: '{weight} kg is {over} kg over the limit of the class ({limit} kg).\n\nIFMA §11.3.1: the boxer must not be over the limit, or the boxer loses the bout by Walk Over. With the approval of the Technical Delegate, a U24 boxer can have 0.5 kg more (§11.3.4).\n\nConfirm: mark the boxer ready with this weight.\nCancel: the boxer stays not ready. End Weigh-in then gives the Walk Over.',
    proposedBy: '{name} proposes to end the weigh-in ({time}).',
    proposalCounts: '{ready} · {notReady}. A bout with one boxer who is not ready ends by Walk Over.',
    confirmers: 'Who can confirm: {names}, or an admin.',
    confirmersAdminOnly: 'Who can confirm: another manager of the tournament or an admin.',
    waiting: 'You proposed the End. A second person must confirm it.',
    confirmPrompt: 'End the weigh-in of this day? A bout with one boxer who is not ready ends by Walk Over.',
    cancelProposal: 'Cancel the proposal',
    endHint: 'With two or more managers, End Weigh-in needs two people: one person proposes the End, and another manager or an admin confirms it. With one manager, the End runs at once.',
    proposed: 'You sent the proposal. Another manager or an admin must confirm it.',
  },
  country: {
    label: 'Country',
    all: 'All countries',
    names: {
      AD: 'Andorra', AL: 'Albania', AT: 'Austria', BA: 'Bosnia and Herzegovina',
      BE: 'Belgium', BG: 'Bulgaria', BY: 'Belarus', CH: 'Switzerland', CY: 'Cyprus', CZ: 'Czechia',
      DE: 'Germany', DK: 'Denmark', EE: 'Estonia', ES: 'Spain', FI: 'Finland', FR: 'France',
      GB: 'United Kingdom', GR: 'Greece', HR: 'Croatia', HU: 'Hungary',
      IE: 'Ireland', IS: 'Iceland', IT: 'Italy', LI: 'Liechtenstein', LT: 'Lithuania',
      LU: 'Luxembourg', LV: 'Latvia', MC: 'Monaco', MD: 'Moldova', ME: 'Montenegro',
      MK: 'North Macedonia', MT: 'Malta', NL: 'Netherlands', NO: 'Norway', PL: 'Poland',
      PT: 'Portugal', RO: 'Romania', RS: 'Serbia', RU: 'Russia', SE: 'Sweden',
      SI: 'Slovenia', SK: 'Slovakia', SM: 'San Marino', TR: 'Türkiye', UA: 'Ukraine',
      VA: 'Vatican City', XK: 'Kosovo',
    },
  },
  notifications: {
    title: 'Notifications', markAllRead: 'Mark all read', empty: 'No notifications',
    unreadOnly: 'Unread only', showAll: 'Show all', dismiss: 'Dismiss',
    pushEnabled: 'Push notifications enabled', pushEnable: 'Enable push notifications',
    pushPrompt: {
      title: 'Hear about your bouts',
      body: 'Enable push notifications to get your bout number, ring and day on this device.',
      enable: 'Enable', later: 'Not now',
    },
    // #557 — above the End button of the Weigh-in tab and the Check-in tab.
    // One text for both tabs: an open ring and a one-manager championship
    // make no End proposal.
    pushOffHint: 'Push notifications are off on this device. You see the notices about the End only in the app.',
    // #557 — the Officials tab, for an official in the referee pool.
    pushOffHintOfficial: 'Push notifications are off on this device. You see the calls to the ring and your list of bouts only in the app.',
    // #557 — the error toast of a failed "Enable" (the bell, the banner, the push-off line).
    // A refusal with a code shows the text of `errors` instead.
    pushEnableFailed: 'The app could not enable push notifications on this device. Try again later.',
    pushBlocked: 'The browser blocks push notifications for this site. Allow them in the site settings of the browser.',
    // #557 review — the error toast of a failed "Disable" (the push toggle of the bell).
    pushDisableFailed: 'The app could not disable push notifications on this device. Try again later.',
    // One entry per message key (`notifications.template` on the row, or the
    // type). `{name}` is a parameter; a `[[ ... ]]` segment is dropped when a
    // parameter inside it is empty. `{role}` is mapped through `roles`.
    messages: {
      // {name} since #479 (never the email, #452). A role request written
      // before #479 carries {email} instead; the [[ ]] part shows it for
      // the 14-day life of such a row.
      role_request: { title: '{name}[[{email}]] requested the {role} role', body: '' },
      role_approved: { title: 'Your {role} role request was approved', body: '' },
      role_rejected: { title: 'Your {role} role request was rejected', body: '' },
      join_accepted: { title: 'You were accepted to {team}', body: '' },
      join_declined: { title: 'Your request to join {team} was rejected', body: '' },
      team_join_approved: { title: 'Team join approved: {team}', body: 'Your request to join {team} as {role} was approved.' },
      team_join_rejected: { title: 'Team join rejected: {team}', body: 'Your request to join {team} as {role} was rejected.' },
      coach_assigned: { title: 'You were assigned as {role} to {team}', body: '' },
      team_join_request: { title: 'Team join request: {team}', body: '{name} asks to join {team} as {role}. Approve or reject the request on the team page.' },
      athlete_team_request: { title: 'Athlete join request: {team}', body: '{athlete} asks to join {team}. Approve or reject the request in Admin → Requests, or on the team page.' },
      team_claim_request: { title: 'Team claim: {team}', body: '{name} claims {team} as {role}. Approve or reject the claim in Admin → Requests → Claims.' },
      team_claim_approved: { title: 'Team claim approved: {team}', body: 'Your claim of {team} as {role} was approved.' },
      team_claim_rejected: { title: 'Team claim rejected: {team}', body: 'Your claim of {team} as {role} was rejected.' },
      athlete_team_request_approved: { title: 'Team join approved: {team}', body: 'Your request to join {team} as an athlete was approved.' },
      athlete_team_request_rejected: { title: 'Team join rejected: {team}', body: 'Your request to join {team} as an athlete was rejected.' },
      athlete_team_removed: { title: 'Removed from team: {team}', body: 'A coach removed you from {team}. Your bout history stays on your athlete page.' },
      athlete_team_invite: { title: 'Team invitation: {team}', body: '{team} invites you to join the team. Approve or reject the invitation on your profile.' },
      athlete_team_invite_review: { title: 'Team invitation: {athlete}', body: '{team} invites {athlete}, who has no account. Approve or reject the invitation in Admin → Requests.' },
      athlete_team_invite_approved: { title: 'Invitation approved: {athlete}', body: '{athlete} is now in {team}.' },
      athlete_team_invite_rejected: { title: 'Invitation rejected: {athlete}', body: '{athlete} does not join {team}. The invitation was rejected.' },
      athlete_claim: { title: 'Athlete claim: {athlete}', body: '{name} claims the athlete record of {athlete}. Approve or reject the claim in Admin → Requests, or on the team page.' },
      // #569 — a claim after several wrong birth dates on the record.
      athlete_claim_unchecked: { title: 'Athlete claim: {athlete}', body: '{name} claims the athlete record of {athlete}. The birth date was not checked. Approve or reject the claim in Admin → Requests, or on the team page.' },
      athlete_claim_approved: { title: 'Athlete record claim approved', body: 'Your claim of the athlete record {athlete} was approved.' },
      athlete_claim_rejected: { title: 'Athlete record claim rejected', body: 'Your claim of the athlete record {athlete} was rejected.' },
      // #593 — both corners by name; a corner that waits for a result names the bout.
      bout_live_corners: { title: 'Bout #{boutNumber} is now live: [[{redShort}]][[winner of bout #{redFrom}]][[loser of bout #{redLoserFrom}]] (red) vs [[{blueShort}]][[winner of bout #{blueFrom}]][[loser of bout #{blueLoserFrom}]] (blue)', body: '{ring}. Red: [[{red}]][[winner of bout #{redFrom}]][[loser of bout #{redLoserFrom}]]. Blue: [[{blue}]][[winner of bout #{blueFrom}]][[loser of bout #{blueLoserFrom}]].' },
      bout_upcoming_corners: { title: 'Bout #{boutNumber} is up next: [[{redShort}]][[winner of bout #{redFrom}]][[loser of bout #{redLoserFrom}]] (red) vs [[{blueShort}]][[winner of bout #{blueFrom}]][[loser of bout #{blueLoserFrom}]] (blue)', body: '{ring}. Red: [[{red}]][[winner of bout #{redFrom}]][[loser of bout #{redLoserFrom}]]. Blue: [[{blue}]][[winner of bout #{blueFrom}]][[loser of bout #{blueLoserFrom}]].' },
      bout_assigned_red: { title: 'Bout #{boutNumber}: {athlete}', body: '{athlete} is in the red corner of bout #{boutNumber} at {tournament}{where}.[[ Opponent: {opponent}.]][[ Category: {category}.]]' },
      bout_assigned_blue: { title: 'Bout #{boutNumber}: {athlete}', body: '{athlete} is in the blue corner of bout #{boutNumber} at {tournament}{where}.[[ Opponent: {opponent}.]][[ Category: {category}.]]' },
      bouts_planned: { title: 'Bouts planned: {tournament}', body: '{count} bout(s) at {tournament} involve you or your boxers. Open the bout list for the ring and the day.' },
      bout_changed: { title: 'Bout #{boutNumber} moved', body: 'Bout #{boutNumber} at {tournament} is now[[{where}]].[[ {red} vs {blue}.]]' },
      bouts_moved: { title: 'Bouts moved: {tournament}', body: '{count} bout(s) at {tournament} moved. Bout → ring, place in line (before): {moves}.' },
      bouts_moved_count: { title: 'Bouts moved: {tournament}', body: '{count} bouts moved to another ring or place. Open the bout list.' },
      registration_confirmed: { title: 'Registration confirmed: {tournament}', body: '{athlete} is confirmed for {tournament}[[ ({category})]].' },
      // #535 — a change to a registration. #575: also from inside the team; it goes to the coach who registered the athlete and to the account of the athlete, never to the actor.
      registration_created: { title: 'New registration: {tournament}', body: '{athlete} is registered for {tournament}[[ ({category})]].' },
      registration_unconfirmed: { title: 'Registration unconfirmed: {tournament}', body: '{athlete} is registered for {tournament}, but not confirmed.' },
      registration_removed: { title: 'Registration removed: {tournament}', body: '{athlete} is removed from {tournament}[[ ({category})]].' },
      registration_category_changed: { title: 'Category changed: {athlete}', body: '{athlete} at {tournament}: {from} → {category}.' },
      // #535 — the first End sends the held category changes to a person with no summary.
      category_changes_summary: { title: 'Category changes: {tournament}', body: '{count} of your boxers have a new category. Open the list of boxers.' },
      // #495 — the summaries of the moments: ONE notice for each person.
      // #535 — a summary of a coach gives counts, not names.
      checkin_summary: { title: 'Check-in closed: {tournament}', body: 'Ready: {ready}. Absent: {absent}.[[ Won by Walk Over: {wonByWalkover}.]][[ Category changes: {categoryChangeCount}.]]' },
      checkin_summary_ready: { title: 'Check-in closed: {tournament}', body: '{athlete} is ready.[[ New category: {newCategory} (was {oldCategory}).]]' },
      checkin_summary_absent: { title: 'Check-in closed: {tournament}', body: '{athlete} is marked absent. Ask the manager if this is wrong.[[ New category: {newCategory} (was {oldCategory}).]]' },
      weighin_summary: { title: 'Weigh-in closed: {tournament}, {day}', body: 'Ready: {ready}. Absent: {absent}.[[ Won by Walk Over: {wonByWalkover}.]][[ Category changes: {categoryChangeCount}.]]' },
      bouts_locked: { title: 'Bouts final: {tournament}', body: '{count} bout(s)[[: {perDay}]]. Open the bout list for the rings and the order.' },
      bouts_changed: { title: 'Bouts changed: {tournament}', body: '{count} bout(s)[[: {perDay}]]. The list changed after the last lock. Open the bout list for the rings and the order.' },
      bouts_locked_athlete: { title: 'Bouts final: {tournament}', body: '{count} bout(s): {lines}.' },
      bouts_changed_athlete: { title: 'Bouts changed: {tournament}', body: '{count} bout(s): {lines}. The list changed after the last lock.' },
      // #557 — the managers: the End proposal of a championship (#548), and the summary of each End.
      weighin_end_proposed: { title: 'End Weigh-in proposed: {tournament}, {day}', body: 'Ready: {ready} of {total}. Not marked: {unmarked}. Open the Weigh-in tab. Confirm or cancel the End there.' },
      weighin_closed_manager: { title: 'Weigh-in closed: {tournament}, {day}', body: 'Ready: {ready}. Absent: {absent}. Walk Over: {woCount}.[[ Both boxers are absent in bouts {bothAbsent}. Decide these bouts by hand.]]' },
      checkin_closed_manager: { title: 'Check-in closed: {tournament}', body: 'Ready: {ready}. Absent: {absent}. Walk Over: {woCount}.[[ Both boxers are absent in bouts {bothAbsent}. Decide these bouts by hand.]]' },
      // #557 — the officials: the call of the ring, and the seat list. {role}
      // and {seats} name the seat through `roles`.
      official_up_next: { title: 'Bout #{boutNumber} is up next: {ring}', body: 'Go to {ring}. You are the {role} of bout #{boutNumber}.' },
      official_now_live: { title: 'Bout #{boutNumber} is live: {ring}', body: 'Go to {ring} now. You are the {role} of bout #{boutNumber}.' },
      officials_assigned: { title: 'Your bouts as an official: {tournament}', body: '[[You are an official in {count} bout(s): {seats}.]][[ Removed: {removed}.]]' },
      officials_locked: { title: 'Your bouts as an official: {tournament}', body: 'The bouts are locked. You are an official in {count} bout(s): {seats}.' },
    } as Record<string, { title: string; body: string }>,
    // #495 — the bell groups two or more notices of one type for one
    // tournament. Only these organization types: a time-critical notice
    // (`bout_upcoming`, `bout_live`) always stays a row of its own.
    groups: {
      registration_confirmed: '{n} boxers confirmed: {tournament}',
      registration_created: '{n} boxers registered: {tournament}',
      registration_unconfirmed: '{n} boxers unconfirmed: {tournament}',
      registration_removed: '{n} boxers removed: {tournament}',
      registration_category_changed: '{n} category changes: {tournament}',
      bout_assigned: '{n} bout notices: {tournament}',
      bout_changed: '{n} bout changes: {tournament}',
    } as Record<string, string>,
  },
  // The bout form of a manager (create and edit). It was English in every language (2026-09-26).
  boutForm: {
    createTitle: 'Create Bout',
    editTitle: 'Bout {n} — Edit',
    noMatches: 'No matches',
    experienceTip: 'Bout experience',
    boutsBadge: '{n}b',
    ageBadge: '{n}y',
    boutNumber: 'Bout # *',
    scoredLocked: 'Scored — verdict submitted. Status is locked.',
    // #552 — one word, one meaning: the app calls this state "Live".
    statusHint: 'Set to Live to start this bout.',
    statusPending: 'Pending',
    statusCurrent: 'Live',
    genderMismatch: 'Both boxers must be the same gender. ({red} vs {blue})',
    redCorner: 'Red corner',
    blueCorner: 'Blue corner',
    athlete: 'Boxer',
    winnerOfBout: 'Winner of Bout',
    searchAthlete: 'Search boxer...',
    selectBout: '— select bout —',
    auto: '(auto)',
    weightClass: 'Weight Class *',
    formula: 'Bout formula:',
    rest: '· rest {rest}',
    rounds: 'Rounds', rounds3: '3 rounds (IFMA)', rounds5: '5 rounds (LMF)',
    roundsLocked: 'The rounds change only while the bout is pending and has no score.',
    day: 'Tournament Day',
    notAssigned: '— not assigned —',
    ringRefHint: '(cannot be a side judge)',
    none: '— none —',
    assignJury: 'Assign Jury',
    juryHintEdit: '(jury pool only · replaces existing)',
    juryHintCreate: '(jury pool only · optional)',
    keepExisting: '— keep existing —',
    sideJudgesHint: '({n}/5 — self-assign from bout page)',
    saveChanges: 'Save changes',
    createBout: 'Create bout',
    sameAthlete: 'Red and Blue cannot be the same boxer',
  },
  // The Plan Officials modal of a manager (2026-09-26).
  planOfficials: {
    title: 'Plan Officials',
    ariaLabel: 'Plan officials',
    selectRing: '— select ring —',
    rotation: 'Referees for rotation',
    colorTip: 'Distribution color',
    juryPoolTip: 'Jury pool',
    selectAll: 'Select all',
    ringRefCandidates: 'Ring referee candidates',
    // #552 — the empty list of the candidates looked broken.
    ringRefCandidatesEmpty: 'First select the referees for rotation.',
    generating: 'Generating…',
    generate: 'Generate Plan',
    neutral: '{n} neutral',
    withConflicts: '{n} with conflicts',
    colRingRef: 'Ring Ref',
    colJudge: 'Judge {n}',
    editedTip: 'Manually edited',
    applyAll: 'Apply All',
    // #588 — at a live event the side judges join at the live bout, so a
    // manager often applies only the ring referees of the plan.
    applyRingRefs: 'Apply Ring Referees',
    ringRefsAssignedOne: 'Ring referee assigned for {n} bout', ringRefsAssignedFew: 'Ring referees assigned for {n} bouts', ringRefsAssignedOther: 'Ring referees assigned for {n} bouts',
    // #589 — each row says why: the order of the bout on its ring that day, the stored officials, the reasons; a legend with the load; a confirm before Apply All.
    orderTip: 'The place of the bout in the order of this ring on this day',
    now: 'Now',
    conflictTip: 'A member of the team of a boxer of this bout',
    lockedTip: 'Apply All keeps the side judges of this bout.',
    legendTitle: 'The seats of each official in this plan: ring referee / side judge',
    blocksHint: 'Each seat keeps one official for a block of bouts, usually 3 bouts and at most 4. A thick line shows where the ring referee changes. A Pro or High bout prefers an experienced ring referee.',
    confirmOne: 'Apply All changes the officials of {n} bout.', confirmFew: 'Apply All changes the officials of {n} bouts.', confirmOther: 'Apply All changes the officials of {n} bouts.',
  },
  // #588 — the officials that the bouts of one ring have now (read-only).
  viewOfficials: {
    title: 'View Officials',
    ariaLabel: 'View officials',
    colBout: 'Bout',
    colStatus: 'Status',
    noBouts: 'This ring has no bouts.',
    notInPool: 'Not in the referee pool',
  },
  // The Manual Assignment and Reassign Bouts modal (2026-09-26).
  manualBouts: {
    saveBoutsOne: 'Save {n} Bout', saveBoutsFew: 'Save {n} Bouts', saveBoutsOther: 'Save {n} Bouts',
    colBout: 'Bout #',
    colDay: 'Day',
    dragTip: 'Drag to reorder',
  },
  // The preview of the open-ring pairs (Match Boxers, 2026-09-26). Challenge stays English: an LMF stage label.
  openRingMatch: {
    title: 'Challenge bout pairs',
    summaryOne: '{n} pair from {total} boxers', summaryFew: '{n} pairs from {total} boxers', summaryOther: '{n} pairs from {total} boxers',
    unmatched: ' · {n} unmatched',
    unmatchedTitle: 'Unmatched ({n})',
  },
  // The referee pool modal: join, add, edit (2026-09-26).
  refereeModal: {
    addTitle: 'Add Referee to Pool',
    // #552 — the title of the edit mode; the name is the subtitle.
    editTitle: 'Edit Referee',
    selectReferee: 'Select referee',
    choose: '— choose —',
    juryPool: 'Jury Pool',
    juryPoolHint: 'Can be assigned as jury for bouts.',
    teamAffiliation: 'Team affiliation',
    // #589, #642 — the app computes the novice status for each seat. The word is also the badge of the Officials tab and the mark of the Plan Officials legend.
    novice: 'Novice',
    noviceSideJudge: 'Novice as side judge', noviceRingReferee: 'Novice as ring referee', noviceNone: 'No',
    noviceSeatsBoth: 'As side judge and as ring referee', noviceSeatsRing: 'As ring referee', noviceSeatsSide: 'As side judge',
    // #641, #642 — the team and the novice status come from the profile of the official.
    profileInfo: 'The team and the novice status come from the page of the official.',
    availableDays: 'Available days',
    daysHint: 'Uncheck all = available all days',
  },
  // The tournament form (create and edit, 2026-09-26). The two aria labels are the names that e2e specs look for.
  tournamentForm: {
    ariaEdit: 'Edit tournament',
    ariaCreate: 'Create tournament',
    // #552 — the title of the edit mode. The aria name stays ariaEdit (pinned).
    editTitle: 'Edit Tournament',
    endDate: 'End date',
    multiDay: '(multi-day)',
    type: 'Type',
    contactPhone: 'Contact phone',
    // #532
    description: 'Description',
    allAgeGroups: 'All age groups',
    ageGroupsNone: 'Select at least one age group, or turn on All age groups.',
  },
  // The Join as Athlete modal (2026-09-26). {name} and {team} render bold (utils/richText.tsx).
  joinTeam: {
    youAre: 'You\'re {name}. Send a request to join {team} as athlete.',
    coachApproves: 'A coach of {team} will need to approve your request before you appear in their roster.',
    createProfile: 'Create your athlete profile to join {team}.',
    sendRequest: 'Send request',
    createAndSend: 'Create + send request',
  },
  // The small labels of the other modals (2026-09-26). bulkRegisterAria is the name that e2e specs look for.
  modalLabels: {
    bulkRegisterAria: 'Bulk register athletes',
    weightWas: 'was {n}',
    weightNew: 'new',
    editAthleteRecord: 'Edit Athlete Record',
    manageCoach: 'Manage Coach',
    moveBoutTip: 'Click to move this bout',
  },
  // #604 — the broadcast overlay of a ring (pages/RingOverlay.tsx).
  overlay: {
    next: 'Next',
  },
  // #559 — the text of a success that the API answers with a `code`. A count
  // has the three forms of countLabel() (`{n}`); the page never shows the
  // English `message` of the answer.
  success: {
    DONE: 'Done',
    DAY_STARTED: { one: 'Day started: {n} bout is live.', few: 'Day started: {n} bouts are live.', other: 'Day started: {n} bouts are live.' },
    PLAN_CONFIRMED: { one: '{n} bout created from the plan', few: '{n} bouts created from the plan', other: '{n} bouts created from the plan' },
    BOUTS_REASSIGNED: { one: '{n} bout reassigned.', few: '{n} bouts reassigned.', other: '{n} bouts reassigned.' },
    BOUTS_CREATED: { one: '{n} bout created.', few: '{n} bouts created.', other: '{n} bouts created.' },
    OPEN_RING_BOUTS_CREATED: { one: '{n} Challenge bout created.', few: '{n} Challenge bouts created.', other: '{n} Challenge bouts created.' },
    OPEN_RING_SKIPPED: ' Skipped: {skipped} (they already have a bout).',
    BOUTS_RESET: {
      one: 'Reset complete: {n} bout deleted. Brackets back to draft: {brackets}. The tournament is unlocked.',
      few: 'Reset complete: {n} bouts deleted. Brackets back to draft: {brackets}. The tournament is unlocked.',
      other: 'Reset complete: {n} bouts deleted. Brackets back to draft: {brackets}. The tournament is unlocked.',
    },
    // #578
    ATHLETES_MERGED: 'The records are merged into {name}.',
  },
  errors: {
    // #559 — a code on each error answer that had none (slice 2).
    NO_AGE_GROUP_FITS: 'No IFMA age group fits an athlete of {age} in the competition year. Choose the age group.',
    USE_LEAVE_TEAM: 'To leave a team, use Leave team.',
    NO_BOUTS_TO_START: 'This day has no pending bout with a ring.',
    INVALID_CREDENTIALS: 'The email or the password is not correct.',
    JURY_CLAIM_SELF_ONLY: 'You can claim a bout only for yourself.',
    OWN_TEAM_REGISTRATIONS_ONLY: 'You can change only the registrations of your own team.',
    JURY_ROLE_REQUIRED: 'Only a person with the jury role can claim a bout.',
    ONLY_HC_DELETE_TEAM: 'Only the head coach or an admin can delete a team.',
    COACH_ROLE_REQUIRED_TO_CLAIM: 'You need the Coach or the Head Coach role to claim a team. Request it on the Profile page.',
    HEAD_COACH_ROLE_REQUIRED: 'You need the Head Coach role to create a team. Request it on the Profile page.',
    USER_NOT_JURY: 'This person does not have the jury role.',
    NOT_FOUND: 'Not found.',
    ATHLETE_RECORD_NOT_FOUND: 'Athlete record not found.',
    // #578 — the refusals of a merge of two athlete records.
    MERGE_SAME_RECORD: 'A record cannot merge into itself.',
    MERGE_TWO_ACCOUNTS: 'Each record is linked to a different account. Unlink one account first.',
    MERGE_RECORDS_MET: 'The two records met in bout #{boutNumber} of {tournament}: they are two people.',
    MERGE_SAME_TOURNAMENT: 'Both records are registered in {tournaments}. Remove one of the two registrations first.',
    MERGE_PENDING_REQUEST: 'The record has a pending claim, team request or team invitation. Approve or reject them first.',
    MERGE_LIVE_BOUT: 'Bout #{boutNumber} of one of the records is live. Merge the records after its verdict.',
    CLAIM_NOT_FOUND: 'The claim is not found, or it is already resolved.',
    RING_NOT_FOUND: 'Ring not found.',
    TEAM_MEMBER_NOT_FOUND: 'This person is not a member of this team.',
    NO_JURY_ASSIGNED: 'This bout has no jury.',
    USER_ALREADY_IN_TEAM: 'This person is already a member of this team.',
    TEAM_HAS_COACH: 'This team already has a coach.',
    STORAGE_NOT_CONFIGURED: 'The file storage is not set up. Ask an admin.',
    ONLY_COACH_APPROVE_MEMBERS: 'Only a coach of this team, a team manager or an admin can approve a member.',
    ONLY_COACH_VIEW_MEMBERS: 'Only a coach of this team, a team manager or an admin can see the pending members.',
    ONLY_HC_REMOVE_MEMBERS: 'Only the head coach, a team manager or an admin can remove a member.',
    TOO_MANY_REQUESTS: 'Too many attempts. Wait some minutes, then try again.',
    // #290 — the pg statement_timeout (#210) aborted the query.
    QUERY_TIMEOUT: 'The request took too long and was stopped. Try again.',
    // ── users-athlete-split refactor ──────────────────────────────────────
    USE_ATHLETES_ENDPOINT: 'Athlete fields ({fields}) must be edited via the athlete profile, not the user profile.',
    USE_ATHLETE_JOIN_ENDPOINT: 'To join a team as athlete, use the Join as Athlete button.',
    ATHLETE_IDENTITY_EXISTS: 'An athlete with this name and birth date already exists. Try claiming the existing record.',
    ALREADY_HAS_ATHLETE_PROFILE: 'You already have an athlete profile. Use the edit form to update.',
    NO_ATHLETE_PROFILE: 'No athlete profile found.',
    PENDING_REQUEST_EXISTS: 'You already have a pending request for this team.',
    CLAIM_ALREADY_PENDING: 'You already have a pending claim for this athlete record.',
    CLAIM_BIRTH_DATE_MISMATCH: 'The birth date does not match the athlete record. Check the date. You can also ask your coach to check the athlete record.',
    CLAIM_ATTEMPTS_LOCKED: 'Too many wrong birth dates. Try again in 24 hours. You can also ask your coach to check the athlete record.',
    TEAM_CLAIM_ALREADY_PENDING: 'You already have a pending claim for this team.',
    CLAIMANT_HAS_ATHLETE_PROFILE: 'This person already has an athlete profile. Reject the claim, or ask a team manager to unlink the other record first.',
    ALREADY_IN_TEAM: 'You are already in this team.',
    ONLY_COACH_VIEW_REQUESTS: 'Only coaches of this team can view athlete requests.',
    ONLY_COACH_RESOLVE: 'Only coaches of this team can resolve athlete requests.',
    REQUEST_NOT_FOUND: 'Request not found.',
    ALREADY_RESOLVED: 'This request has already been resolved.',
    MEMBER_NOT_FOUND: 'This person has no request in this team.',
    JURY_ALREADY_ASSIGNED: 'Another jury member already holds this bout.',
    INVALID_GENDER: 'Gender must be Male or Female.',
    BIRTH_DATE_REQUIRED: 'Birth date is required.',
    TEAM_ID_REQUIRED: 'Team is required.',
    NAME_REQUIRED: 'First name and last name are required.',
    INVALID_WEIGHT: 'Weight must be a positive number.',
    INVALID_COUNTRY: '{field} must be a valid European country code.',
    INVALID_MAX_WEIGHT_KG: 'Max weight (kg) must be a positive number.',
    PLAN_ALREADY_CONFIRMED: 'Plan already confirmed. Reset bouts first to modify.',
    INVALID_EXPERIENCE: 'Experience must be a non-negative integer.',
    TEAM_NOT_FOUND: 'Team not found.',
    NAME_COLLIDES_WITH_EXISTING_AR: 'A different athlete already exists with this name and birth date.',
    DRAW_NOT_ALLOWED_BRACKET_BOUT: 'Draw not allowed — this bout feeds into bout #{boutNumber}. A winner must be declared.',
    DRAW_NOT_ALLOWED_NON_CHALLENGE: 'Draw is only allowed for open ring bouts. A winner must be declared.',
    DRAW_PAIR_INVARIANT: 'A DRAW verdict requires both winner=draw and outcome=DRAW. They cannot be set independently.',
    INVALID_OUTCOME_CODE: 'Invalid outcome "{outcome}". Must be one of: {valid}.',
    SCORED_REQUIRES_VERDICT: 'Bout status cannot be set to scored directly. Submit a jury verdict instead.',
    VERDICT_ALREADY_EXISTS: 'Verdict already submitted for this bout.',
    REST_TIME_VIOLATION: '{athleteName} has another bout within {gapMinutes} min (bout #{conflictBoutNumber}). IFMA requires 120 min rest.',
    SAME_TEAM_MATCH: '{red} and {blue} are both from {team}. The matcher had no other opponent in their class. Change the pair if you do not want it.',
    RING_CAPACITY_EXCEEDED: 'No ring fits {bracket} — every ring\'s max weight is below the bracket\'s class. Bouts placed anyway; review ring caps.',
    BREAK_REQUIRED: 'Bout #{boutNumber} has only {gapMinutes} min rest from bout #{parentBoutNumber}. IFMA needs 120 min — schedule a break before this bout.',
    MAX_CONTESTS_PER_DAY: '{bracket}: a boxer who wins through has {contests} bouts on day {day}. IFMA allows 3 bouts in one day. Add a day, or accept the plan.',
    PLAN_MOVE_BREAKS_ORDER: 'Cannot move: bout #{childPosition} would run before bout #{parentPosition}, whose winner it needs.',
    PLAN_ORDER_BROKEN: 'Bout #{childPosition} runs before bout #{parentPosition}, whose winner it needs. Move one of them first.',
    PLAN_SOURCE_ORDER_INVALID: 'Plan is inconsistent: bout #{childPosition} expects the winner of bout #{parentPosition}, which is not in the plan. Regenerate the plan.',
    RING_NOT_IN_TOURNAMENT: 'Ring not found in this tournament.',
    BRACKET_NOT_IN_TOURNAMENT: 'Bracket not found in this tournament.',
    BOUT_RING_CAP_EXCEEDED: 'Bout #{boutNumber} ({ageGroup} {weightClass}) exceeds ring {ringName}\'s age/weight limits. Moved anyway — double-check the assignment.',
    SESSION_EXPIRED: 'Your session has expired. Please sign in again.',
    OAUTH_FAILED: 'The Google sign-in did not complete. Try again.',
    ACCOUNT_EXISTS_UNLINKED: 'An account with this email address already exists. Sign in with your email and password.',
    BOUT_NUMBER_TAKEN: 'Bout #{boutNumber} is already used in this tournament. Pick another number.',
    PLAN_BOUT_NUMBER_TAKEN: 'Bout #{boutNumber} was made while the plan was confirmed. Delete the bouts made by hand, then confirm the plan again.',
    PLAN_CHANGED: 'The plan changed while it was confirmed. Open it again and confirm.',
    RING_ALREADY_HAS_LIVE_BOUT: 'Ring already has a live bout (#{boutNumber}). Finish or score it first.',
    RING_BUSY_NOT_STARTED: 'Ring {ring} did not start: bout #{boutNumber} of another day is still live there. Finish or score it, then start the day again.',
    BOUT_NOT_IN_TOURNAMENT: 'Bout not found in this tournament.',
    BOUTS_LOCKED_CANNOT_CONFIRM: 'The bout list is locked. Unlock the bout list to change the confirmed status.',
    REGISTRATION_NOT_IN_TOURNAMENT: 'Registration not found in this tournament.',
    REFEREE_DATES_INVALID: 'These dates are not tournament days: {dates}.',
    TOURNAMENT_LOCKED_ATHLETE_SWAP: 'Tournament is locked — boxers were reassigned anyway. Roster may diverge from the registration list.',
    ALREADY_SIDE_JUDGE: 'You are already a side judge for this bout.',
    SCORES_TIED_WP_NOT_ALLOWED: 'Scores are tied ({redScore}-{blueScore}). A decision-by-points cannot declare a winner — use DRAW or fix scores.',
    END_DATE_BEFORE_START: 'End date must be on or after start date.',
    CANNOT_UNLOCK_SCORED_BOUTS: 'Cannot unlock: scored bouts exist. Tournament is in progress.',
    TOURNAMENT_TYPE_LOCKED: 'Cannot change the tournament type: bouts exist. Delete the bouts first.',
    TOURNAMENT_NOT_FOUND: 'Tournament not found.',
    BRACKET_NOT_FOUND: 'Bracket not found.',
    PLAN_ITEM_NOT_FOUND: 'This planned bout no longer exists. Reload the plan.',
    PLAN_DRAFT_EXISTS: 'A draft plan exists. Delete the draft plan first, then change the brackets.',
    BRACKET_LOT_INVALID: 'The draw of this preview is not valid any more. Draw again.',
    BRACKET_GENDER_MIXED: 'Every boxer of a bracket must have the gender of the bracket.',
    BRACKET_SEED_MISMATCH: 'Every boxer of the bracket must be registered in {ageGroup} {weightClass}.',
    BRACKET_SEED_ABSENT: 'A boxer of this draw is marked absent at the check-in. Draw again.',
    BRACKET_NEEDS_TWO_ATHLETES: 'A bracket needs at least 2 boxers in the group who are confirmed and not marked absent.',
    NO_RINGS: 'Add at least one ring first.',
    NO_DRAFT_BRACKETS: 'There is no draft bracket to schedule.',
    NO_PLAN: 'There is no bout plan. Generate the plan first.',
    TOURNAMENT_DAYS_IN_USE: 'Bouts or planned bouts stand on {days}. Move the bouts to another day or reset the draft plan first, or keep those days.',
    COACH_EDITS_LOCKED_BY_BOUTS: 'Unlock the bout list first: coach corrections stay disabled while the bout list is locked.',
    COACH_EDITS_LOCKED_BY_REGISTRATION: 'Unlock registration first: coach corrections stay disabled while registration is locked.',
    REFEREE_ROLE_REQUIRED: 'Only a referee or a jury member can join the referee pool.',
    INVALID_DATETIME: '{field} must be a date and time.',
    INVALID_TOURNAMENT_TYPE: 'The type must be championship, open ring, or championship + open ring.',
    TOURNAMENT_LOCKED_ADMIN_DELETE: 'Tournament is locked. Only admin can delete a locked tournament.',
    RING_NAME_ALREADY_EXISTS: 'Ring name already exists.',
    CANNOT_DELETE_RING_BOUTS_ASSIGNED: 'Cannot delete ring: bouts are assigned to it.',
    COACH_EDIT_PHASE_LOCKED: 'Coach edit phase is locked.',
    ATHLETE_ALREADY_REGISTERED: 'This athlete is already registered in this tournament.',
    ATHLETE_NOT_IN_TEAM: 'The athlete does not belong to this team.',
    ATHLETE_ARCHIVED: 'This athlete record is archived.',
    ATHLETE_HAS_NO_TEAM: 'The athlete is not in a team.',
    JOIN_REQUEST_PENDING: 'The athlete asked to join this team. Approve the join request on the Requests tab.',
    INVITE_ALREADY_PENDING: 'This athlete already has a pending invitation to this team.',
    INVITE_NOT_FOUND: 'The invitation was not found.',
    INVITE_FOR_ATHLETE: 'The athlete has an account and decides on the invitation.',
    CANNOT_APPROVE_OWN_INVITE: 'You cannot approve your own invitation. Another team manager or an admin must approve it.',
    INVITE_EXPIRED: 'The person who sent the invitation no longer coaches this team.',
    INVITE_RECENTLY_REJECTED: 'The invitation to this team was rejected less than {days} days ago.',
    INVITE_PENDING: 'This team invited you already. Approve the invitation on your profile.',
    ATHLETE_HAS_OPEN_REGISTRATION: 'The athlete has a registration in {tournament}, which has not ended. Remove the registration first.',
    AGE_GROUP_MISMATCH: 'The athlete is {age} in the competition year, outside age group {ageGroup} ({min}–{max}).',
    // #532 — the allowed age groups of a tournament.
    AGE_GROUP_NOT_ALLOWED: 'This tournament does not take the age group {ageGroup}. Allowed: {allowed}.',
    AGE_GROUPS_IN_USE: 'Boxers are registered in {ageGroups}. Move or remove those registrations first, or keep those age groups.',
    REGISTRATION_IN_BRACKET: 'The boxer is seeded in a bracket. Delete the bracket first.',
    CANNOT_UNCONFIRM_BRACKET_EXISTS: 'Cannot unconfirm — the boxer is in a bracket. Delete the bracket first.',
    ATHLETE_ASSIGNED_TO_BOUT: 'The boxer has a bout. Delete the bout first.',
    ONLY_TM_ADD_REFEREES: 'Only tournament managers can add other users to the referee pool.',
    ONLY_MANAGER_CONFIRMS: 'Only managers of this tournament can confirm a registration.',
    CANNOT_LEAVE_ACTIVE_BOUT: 'Cannot leave: you are an official of the live bout #{boutNumber}.',
    // #589 — the jury pool needs the jury role; a plan of the officials names each bout once.
    JURY_POOL_NEEDS_JURY_ROLE: 'Only an account with the jury role can be in the jury pool.',
    DUPLICATE_BOUT_IN_PLAN: 'The plan names one bout two times. Generate the plan again.',
    // #589 — Plan Officials: the reasons of a plan row (warnings), and the refusals of Apply All. Each refusal names the bout and the person.
    PLAN_OFFICIAL_TEAM_CONFLICT: '{name} is a member of the team of a boxer of this bout.',
    PLAN_RING_REF_NO_REST: 'Ring referee {name} sat in the bout before in another seat and gets no rest.',
    PLAN_RING_REF_LONG_BLOCK: 'Ring referee {name} sits in {count} bouts in a row. A block has at most 4 bouts.',
    PLAN_SIDE_JUDGE_LONG_BLOCK: 'Side judge {name} sits in {count} bouts in a row. A block has at most 4 bouts.',
    PLAN_HARD_BOUT_NOVICE_REF: 'Ring referee {name} is a novice, and this is a Pro or High bout.',
    PLAN_NO_RING_REF: 'This bout has no ring referee.',
    PLAN_FEW_SIDE_JUDGES: 'Side judges in this bout: {count}. A bout needs at least 3.',
    PLAN_KEPT_SIDE_JUDGES: 'Bout #{boutNumber} keeps its {count} side judges. Apply All writes only its ring referee.',
    // #589 — the rings run at the same time: an official with a seat in another ring in an overlapping time window.
    PLAN_OFFICIAL_OTHER_RING: '{name} has a seat in another ring at the same time: {ring}, bout #{boutNumber}.',
    // #589 — the operator: a maximum of one novice in each panel (the ring referee and the side judges).
    PLAN_TWO_NOVICES: 'This bout has more than one novice official: {names}.',
    // #627 — a swap by hand: an official on a day that the official did not mark (a warning), and a side judge with no referee role (Apply All refuses it).
    PLAN_OFFICIAL_NOT_AVAILABLE: '{name} is not available on the day of this bout ({date}).',
    PLAN_SIDE_JUDGE_NO_REFEREE_ROLE: 'Bout #{boutNumber}: {name} has no referee role and cannot be a side judge.',
    PLAN_SIDE_JUDGE_IS_RING_REF: 'Bout #{boutNumber}: {name} cannot be the ring referee and a side judge of the bout.',
    PLAN_JURY_IS_RING_REF: 'Bout #{boutNumber}: {name} is the jury of the bout and cannot be its ring referee.',
    PLAN_OFFICIAL_NOT_IN_POOL: 'Bout #{boutNumber}: {name} is not in the referee pool of the tournament.',
    PLAN_TOO_MANY_SIDE_JUDGES: 'Bout #{boutNumber}: a bout has a maximum of 5 side judges.',
    PLAN_SIDE_JUDGE_TWICE: 'Bout #{boutNumber}: {name} has two side-judge seats.',
    // #589 — the referee pool. A seat on the live bout stops a removal. A removal frees each seat on a pending bout.
    POOL_MEMBER_ON_LIVE_BOUT: '{name} is an official of the live bout #{boutNumber}. The jury of that bout changes its officials.',
    OFFICIAL_SEATS_FREED: '{name} has no seat now in: {bouts}. Assign other officials there.',
    MUST_JOIN_REFEREE_POOL: 'You must join the referee pool first.',
    MUST_OPT_JURY_POOL: 'You must opt in to the Jury Pool (tick "Jury Pool" on the Officials tab).',
    // #616 — a referee opens the statistics of another official.
    OFFICIAL_STATS_FORBIDDEN: 'You can see only your own statistics.',
    CANNOT_REMOVE_LAST_MANAGER: 'Cannot remove the last tournament manager.',
    MANAGER_NOT_FOUND: 'This user is not a manager of this tournament.',
    NOT_A_TOURNAMENT_MANAGER: 'This user does not have the tournament manager role.',
    WEIGHIN_PROPOSAL_PENDING: 'An End Weigh-in proposal for {date} is pending. Confirm or cancel it first.',
    WEIGHIN_NO_PROPOSAL: 'The tournament has two or more managers, so a second person must confirm the End. Click "End Weigh-in" first to propose it.',
    WEIGHIN_SELF_CONFIRM: 'You cannot confirm your own proposal. Another manager of the tournament or an admin must confirm it (4-eye principle).',
    // #548 — one open proposal for each day, and no End after the End.
    WEIGHIN_PROPOSAL_EXISTS: '{name} already proposed to end the weigh-in of {date}. Confirm or cancel that proposal first.',
    WEIGHIN_ALREADY_ENDED: 'The weigh-in of {date} is already ended.',
    // #549 — a warning: the championship desk accepts the weight (the manager is trusted).
    WEIGHT_OVER_CLASS_LIMIT: '{weight} kg is {over} kg over the limit of the class ({limit} kg). The boxer is ready with this weight.',
    BOTH_ATHLETES_ABSENT: 'Both boxers of bout #{boutNumber} are absent. The bout stays pending and does not start by itself. Decide it by hand.',
    REGISTRATION_LOCKED: 'Registration is locked for this tournament.',
    REGISTRATION_LOCKED_CANNOT_CONFIRM: 'Registration is locked. Unlock registration to change the confirmed status.',
    GENDER_MISMATCH: 'Gender mismatch: Red corner is {redGender}, Blue corner is {blueGender}. Both boxers must be the same gender.',
    SIDE_JUDGE_CANNOT_BE_RING_REF: 'This person is already a side judge for this bout. A side judge cannot also be the Ring Referee.',
    JURY_CANNOT_BE_RING_REF: 'The jury of a bout cannot also be its Ring Referee.',
    INVALID_WINNER: 'Winner must be one of: {allowed}.',
    DAY_ALREADY_STARTED: 'Day already started — {liveCount} bout(s) are live.',
    CANNOT_DELETE_SCORED_BOUT: 'Cannot delete a scored bout.',
    SCORED_BOUTS_BLOCK_DELETE: 'This would delete scored bouts. A scored bout is permanent.',
    MAX_SIDE_JUDGES_REACHED: 'This bout already has the maximum of 5 side judges.',
    OFFICIALS_SKIPPED_NOT_PENDING: 'Bout #{boutNumber} is already live or scored. Its officials did not change.',
    SAME_ATHLETE_BOTH_CORNERS: 'One boxer cannot be in both corners of a bout.',
    TEAM_NAME_TAKEN: 'Team name already taken.',
    INCOMPLETE_PROFILE: 'Please complete your profile (gender and birth date) before joining as an athlete.',
    TEAM_HAS_TOURNAMENT_REGISTRATIONS: 'The team has tournament registrations, so it cannot be deleted.',
    TEAM_NOT_EMPTY: 'The team still has {members} other member(s), {athletes} athlete record(s) and {archived} archived record(s). Only an admin can delete it.',
    BRACKET_BOUTS_EXIST: 'Bracket already has bouts configured. Reset bouts first to regenerate.',
    BOUTS_ALREADY_EXIST: 'Bouts already exist in this tournament. Reset the bouts first.',
    BRACKET_PLAN_NOT_CONFIRMED: 'Confirm the bout plan first. You can confirm the plan only while the tournament has no other bouts.',
    HYBRID_ONE_DAY: 'A Championship + Open Ring tournament runs on one day. Set the end date to the start date, or choose another type.',
    // Admin / user management
    INVALID_ROLE: 'Invalid role. Allowed: {allowed}.',
    EMAIL_ALREADY_EXISTS: 'Email already exists.',
    INVALID_REQUESTED_ROLE: 'Requested role must be one of: {allowed}.',
    ALREADY_HAVE_ROLE: 'You already have the {role} role.',
    ROLE_REQUEST_ALREADY_PENDING: 'You already have a pending request for this role.',
    MUST_BE_ATHLETE_TEAM_COACH: "You must be a coach of the athlete's team.",
    // Athlete records / claims
    MUST_BE_TEAM_COACH: 'You must be an approved coach of this team.',
    // #674 — a coach and an athlete can only keep or raise the bout count.
    EXPERIENCE_DECREASE_NOT_ALLOWED: 'Only an admin or a team manager can lower the bout count. The stored count is {current}.',
    RECORD_NOT_CLAIMED: 'Record is not claimed.',
    RECORD_ALREADY_CLAIMED: 'Record already claimed.',
    CANNOT_APPROVE_OWN_CLAIM: 'You cannot approve your own claim. Another coach or admin must approve it.',
    // Upload / logos
    ONLY_HC_EDIT_TEAM: 'Only the Head Coach of this team can edit the team details.',
    ONLY_HC_EDIT_TEAM_LOGO: 'Only the Head Coach of this team can edit the team logo.',
    ONLY_TM_EDIT_TOURNAMENT_LOGO: 'Only managers of this tournament or admins can edit the tournament logo.',
    // Team promote
    ONLY_HC_PROMOTE: 'Only the Head Coach can promote members.',
    ONLY_HC_DEMOTE: 'Only the Head Coach can demote members.',
    ALREADY_HEAD_COACH: 'This member is already the Head Coach.',
    NOT_HEAD_COACH: 'This member is not a Head Coach.',
    LAST_HEAD_COACH: 'The team needs at least one Head Coach. Promote another member first.',
    TEAM_HAS_HEAD_COACH: 'The team already has a Head Coach. A team has one Head Coach.',
    INVALID_APP_PATH: 'The link must be a page of the app.',
    // Push subscriptions
    INVALID_PUSH_ENDPOINT: 'Push subscription endpoint is not valid.',
    PUSH_FIELD_TOO_LONG: '{field} is too long (max {max} characters).',
    PUSH_TOO_MANY_SUBSCRIPTIONS: 'You have reached the maximum of {max} push devices. Remove an old one first.',
    // Scoring
    SCORES_LIVE_ONLY: 'Scores can only be submitted for live bouts.',
    NOT_ASSIGNED_SIDE_JUDGE: 'You are not a side judge for this bout.',
    POINTS_OUT_OF_RANGE: 'Points must be between 7 and 10 per IFMA rules.',
    INVALID_ROUND_NUMBER: 'Round number must be between 1 and 3.',
    INVALID_NUMERIC_FIELD: '{field} must be a whole number between {min} and {max}.',
    ONLY_JURY_OVERRIDE: 'Only the assigned jury can override round totals.',
    CANNOT_OVERRIDE_AFTER_VERDICT: 'Cannot modify overrides after the verdict is in.',
    ROUND_APPROVED_LOCKED: 'The jury approved round {round}, so it is locked. You cannot change this score.',
    INVALID_ROUNDS: 'A bout has 3 or 5 rounds.',
    ROUNDS_ABOVE_CLASS_MAX: 'This bout allows at most {max} rounds.',
    ROUNDS_LOCKED: 'The rounds of a bout can change only while the bout is pending and has no score.',
    ROUND_SCORE_INVALID: 'Before the Warnings, one boxer must have 10 points and the other 7 to 10. Check the points and the Warnings.',
    ROUND_OUTCOME_MISMATCH: 'The round outcome must match the points: the winner has 10 before the Warnings, and an even round is 10–10.',
    INVALID_ROUND_OUTCOME: 'The round outcome must be Red, Blue or Even.',
    WP_WINNER_HAS_FEWER_POINTS: 'The winner has fewer points ({redScore}-{blueScore}). Correct the totals or the winner.',
    DRAW_NEEDS_EQUAL_SCORES: 'A draw needs equal totals ({redScore}-{blueScore}). Correct the totals or pick a winner.',
    CORNER_SCORES_INCOMPLETE: 'Enter both totals, or leave both empty.',
    ROUND_FEW_CARDS: 'Only {cards} of {min} judges scored round {round}. The jury must confirm the approval.',
    APPROVAL_LOCKED_AFTER_VERDICT: 'The approved rounds cannot change after the verdict.',
    ONLY_JURY_APPROVES_ROUNDS: 'Only the jury assigned to this bout can approve rounds.',
    INVALID_DISPLAY_ROUNDS: 'The approved rounds must be a list of round numbers.',
    BOUT_NOT_FOUND: 'Bout not found.',
    // #601 — the timer of the jury on the ring display
    TIMER_NOT_JURY: 'Only the jury assigned to this bout can show its timer on the ring display.',
    TIMER_BOUT_NOT_LIVE: 'The ring display shows the timer of the live bout only.',
    // Verdict / ring ref
    ONLY_ASSIGNED_JURY_VERDICT: 'Only the jury assigned to this bout can submit a verdict.',
    VERDICT_LIVE_ONLY: 'Verdict can only be submitted for live bouts.',
    RING_REF_REQUIRED_FOR_VERDICT: 'Ring referee must be assigned before submitting a verdict.',
    ONLY_JURY_TM_ASSIGN_RING_REF: 'Only the assigned jury or tournament manager can assign the ring referee.',
    USER_NOT_IN_REFEREE_POOL: 'User is not in the tournament referee pool.',
    // Notifications
    ONLY_ADMIN_TM_JURY_NOTIFY: 'Only Admin, Tournament Manager, or Jury can send notifications.',
    NOT_TOURNAMENT_MANAGER: 'You are not a manager of this tournament.',
    TARGET_NOT_IN_TOURNAMENT: 'Target user is not in this tournament.',
    NOT_JURY_FOR_BOUT: 'You are not the jury for this bout.',
    TARGET_NOT_ASSIGNED_TO_BOUT: 'Target user is not assigned to this bout.',
    // Auth
    INVALID_EMAIL_FORMAT: 'Invalid email format.',
    WEAK_PASSWORD: 'Password must be at least 8 characters with uppercase, lowercase, and a digit.',
    EMAIL_ALREADY_REGISTERED: 'Email already registered.',
    INVALID_VERIFICATION_LINK: 'Invalid or expired verification link. Please request a new one.',
    INVALID_RESET_LINK: 'Invalid or expired reset link. Please request a new one.',
    EMAIL_NOT_VERIFIED: 'Please verify your email before signing in. Check your inbox for a verification link.',
    CACHE_PATTERN_NOT_ALLOWED: 'Cache pattern not allowed: {patterns}.',
    ACCOUNT_LOCKED: 'Too many failed sign-in attempts. Please try again in 15 minutes.',
    CSRF_FAILED: 'Security token expired. Please refresh the page and try again.',
    REFRESH_REUSE_DETECTED: 'Session compromised. Please sign in again.',
    UNAUTHENTICATED: 'Please sign in to continue.',
    INSUFFICIENT_PERMISSIONS: 'You do not have permission for this action.',
    NOT_TEAM_COACH: 'You must be an approved coach of this team.',
    // Validation
    INVALID_UUID: 'Invalid UUID for parameter {param}.',
    INVALID_DATE: '{param} must be a date in YYYY-MM-DD form.',
    ATHLETE_NOT_REGISTERED: 'A corner boxer is not registered in this tournament.',
    INVALID_AGE_GROUP: '{param} must be a known age-group code.',
    // #364 — the one validation control (backend middleware/validate.ts)
    FIELD_REQUIRED: '{field} is required.',
    CONFLICT: 'This conflicts with a record that already exists.',
    // The registration weight, and since #549 the scale weight before Ready
    // at a championship weigh-in.
    WEIGHT_REQUIRED: 'Enter the weight in kilograms.',
    INVALID_BIRTH_DATE: 'Birth date must be a real date, not in the future, within the last 100 years.',
    INVALID_VALUE: 'A value in the request is not allowed ({field}).',
    INVALID_QUERY_VALUE: 'The query parameter {param} must be a single value.',
    VALUE_TOO_LONG: '{field} must be at most {max} characters.',
    // #589 — a list in a request has a size limit.
    LIST_TOO_LONG: 'The list {field} has more than {max} items.',
    WEIGHT_CLASS_NOT_FOUND: 'No weight class matches age group {age_group} for {gender}.',
    REGISTRATION_IN_BOUT_PLAN: 'The boxer is in the draft bout plan. Reset the plan first.',
    TOURNAMENT_HAS_RESULTS: 'The tournament has results. Only an admin can delete a tournament with a scored bout.',
    USER_HAS_OFFICIAL_RECORD: 'A record still references this user; the account was not erased.',
    CANNOT_ERASE_SELF: 'You cannot erase your own account.',
    ERASURE_PHOTO_NOT_DELETED: 'The photo could not be deleted, so the account was not erased. Try again.',
    USER_NOT_FOUND: 'User not found.',
    NOTIFICATION_NOT_FOUND: 'Notification not found.',
    NOTHING_TO_UPDATE: 'Nothing to update.',
    ROW_IN_USE: 'This item is still used by other records. Remove those first.',
    INVALID_REFERENCE: 'The request refers to a record that does not exist.',
    // #641, #642 — the profile of an official.
    OFFICIAL_TEAM_DATE_TAKEN: 'The official already has a team period from this date. Pick another date, or delete that period first.',
    OFFICIAL_ACCREDITATION_DATE_TAKEN: 'The official already has an accreditation from this date.',
    OFFICIAL_PROFILE_ROW_NOT_FOUND: 'This row of the profile does not exist any more. Reload the page.',
    ACCREDITATION_END_BEFORE_START: 'The end of the accreditation is before its start.',
    USER_NOT_AN_OFFICIAL: 'The user has no Referee, Jury or Admin role, so the user has no official profile.',
    OFFICIAL_PROFILE_SELF_EDIT: 'You cannot change your own profile. Ask an admin or another member of the jury.',
    TEAM_HAS_OFFICIALS: 'The team history of an official names this team, so you cannot delete the team. The history keeps each team that an official belonged to.',
    // Brackets / bouts
    BOUT_NUMBER_CONFLICT: 'One of the target bout numbers conflicts with another bout not in this batch. Include all affected bouts, or pick different numbers.',
    // Uploads (#437)
    UPLOAD_TOO_LARGE: 'The file is larger than {max_mb} MB. Choose a smaller photo.',
    UPLOAD_NOT_IMAGE: 'Only image files are accepted (JPEG, PNG, WebP, GIF, AVIF).',
    IMAGE_NOT_DELETED: 'The old image was not deleted. Try again.', // #685
    UPLOAD_REJECTED: 'The upload was rejected ({reason}).',
    UPLOAD_NO_FILE: 'No file was received. Choose a photo and try again.',
  } as Record<string, string>,
};

export type Translations = typeof en;
export default en;
